const translations = {
  en: {
    // Login
    "login.title": "Sign in to your account",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign In",
    "login.submitting": "Signing in...",
    "login.noAccount": "Don't have an account?",
    "login.signUp": "Sign up",
    "login.failed": "Login failed. Please try again.",
    "login.forgotPassword": "Forgot password?",
    "login.forgotTitle": "Reset your password",
    "login.forgotDesc": "Enter your email and we'll send you a link to reset your password.",
    "login.forgotSubmit": "Send Reset Link",
    "login.forgotSubmitting": "Sending...",
    "login.forgotSuccess": "If that email is registered, a reset link has been sent. Check your inbox.",
    "login.forgotBack": "Back to login",
    "login.resetTitle": "Set new password",
    "login.resetDesc": "Enter your new password below.",
    "login.newPassword": "New Password",
    "login.confirmPassword": "Confirm Password",
    "login.resetSubmit": "Reset Password",
    "login.resetSubmitting": "Resetting...",
    "login.resetSuccess": "Password updated! You can now sign in.",
    "login.resetPasswordMismatch": "Passwords do not match",
    "login.resetInvalidToken": "Invalid or expired reset link.",

    // Register
    "register.title": "Create your account",
    "register.firstName": "First Name",
    "register.lastName": "Last Name",
    "register.email": "Email",
    "register.password": "Password",
    "register.submit": "Create Account",
    "register.submitting": "Creating account...",
    "register.hasAccount": "Already have an account?",
    "register.signIn": "Sign in",
    "register.failed": "Registration failed. Please try again.",

    // Dashboard
    "dashboard.title": "My Profiles",
    "dashboard.profileCount": "{count} of {max} profile",
    "dashboard.profileCountPlural": "{count} of {max} profiles",
    "dashboard.createProfile": "Create Profile",
    "dashboard.createFirst": "Create Your First Profile",
    "dashboard.limitReached": "Profile limit reached ({count}/{max})",
    "dashboard.slotsExplainNoCards": "You have {free} free profile included. Register a {cardLabel} to get an additional profile slot for each one.",
    "dashboard.slotsExplainWithCards": "You have {free} free profile + {cards} from your {cardLabelPlural} = {total} profile slots.",
    "dashboard.noProfiles": "No profiles yet",
    "dashboard.noProfilesDesc": "Create your first digital profile to start sharing your business, professional, or personal brand online.",
    "dashboard.views": "views",
    "dashboard.subscriptionUntil": "Plus until",
    "dashboard.freeTier": "Free plan — upgrade to unlock all features",
    "dashboard.edit": "Edit",
    "dashboard.view": "View",
    "dashboard.stats": "Stats",
    "dashboard.upgrade": "Upgrade",
    "dashboard.deleteProfile": "Delete Profile",
    "dashboard.deleteConfirm": "Are you sure you want to delete",
    "dashboard.deleteWarn": "This action cannot be undone.",
    "dashboard.cancel": "Cancel",
    "dashboard.delete": "Delete",
    "dashboard.createNew": "Create New Profile",
    "dashboard.profileName": "Profile Name",
    "dashboard.profileType": "Profile Type",
    "dashboard.tagline": "Tagline",
    "dashboard.themeColor": "Theme Color",
    "dashboard.customColor": "Custom",
    "dashboard.business": "Business",
    "dashboard.professional": "Professional",
    "dashboard.personal": "Personal",
    "dashboard.organization": "{orgLabel}",
    "dashboard.creating": "Creating...",
    "dashboard.orgProfileCount": "{count} of {max} profile",
    "dashboard.orgProfileCountPlural": "{count} of {max} profiles",
    "dashboard.orgLimitReached": "Limit reached ({count}/{max})",
    "dashboard.manageOrg": "Manage",
    "dashboard.noOrgProfiles": "No profiles in this {orgLabel} yet",

    // Layout
    "layout.profiles": "Profiles",
    "layout.cards": "{cardLabelPlural}",
    "layout.subscriptions": "Subscriptions",
    "layout.organizations": "{orgLabelPlural}",
    "layout.account": "Account",
    "layout.installApp": "Install app",
    "layout.logout": "Logout",

    // Organizations
    "orgs.title": "{orgLabelPlural}",
    "orgs.create": "Create {orgLabel}",
    "orgs.creating": "Creating...",
    "orgs.createFailed": "Failed to create {orgLabel}",
    "orgs.name": "Name",
    "orgs.namePlaceholder": "e.g. My Company",
    "orgs.description": "Description",
    "orgs.descriptionPlaceholder": "What does this {orgLabel} do?",
    "orgs.cancel": "Cancel",
    "orgs.save": "Save",
    "orgs.delete": "Delete",
    "orgs.deleteFailed": "Failed to delete {orgLabel}",
    "orgs.deleteConfirmTitle": "Delete {orgLabel}",
    "orgs.deleteConfirmDesc": "This action cannot be undone. The {orgLabel} and its template will be permanently deleted.",
    "orgs.noOrgs": "No {orgLabelPlural} yet.",
    "orgs.noOrgsDesc": "Create a {orgLabel} to manage profiles under a brand.",
    "orgs.profile": "profile",
    "orgs.profiles": "profiles",
    "orgs.backToOrgs": "Back to {orgLabelPlural}",
    "orgs.editOrg": "Edit {orgLabel}",
    "orgs.template": "Base Template",
    "orgs.orgProfiles": "Profiles",
    "orgs.createProfile": "Create Profile",
    "orgs.createProfileDesc": "This profile will be created from the {orgLabel}'s base template.",
    "orgs.createProfileFailed": "Failed to create profile",
    "orgs.profileName": "Profile Name",
    "orgs.jobTitle": "Position / Role",
    "orgs.noProfiles": "No profiles yet.",
    "orgs.noProfilesDesc": "Create a profile to get started.",
    "orgs.deleteProfileTitle": "Delete Profile",
    "orgs.deleteProfileDesc": "This profile will be permanently deleted.",

    // Template Editor
    "template.title": "Base Template",
    "template.description": "Define the default look and structure for new profiles in this {orgLabel}.",
    "template.tagline": "Tagline",
    "template.taglineDesc": "Shared across all profiles in this {orgLabel} (e.g. company slogan).",
    "template.taglinePlaceholder": "e.g. Innovation at your fingertips",
    "template.back": "Back",
    "template.coverImage": "Cover Image",
    "template.uploadCover": "Upload cover image",
    "template.themeColor": "Theme Color",
    "template.themeStyle": "Theme Style",
    "template.blocks": "Default Blocks",
    "template.blocksDesc": "These blocks will be created automatically when a new profile is added to this {orgLabel}.",
    "template.addBlock": "Add Block",
    "template.noBlocks": "No blocks defined. Add blocks to set the default structure.",
    "template.saved": "Template saved",
    "template.saveFailed": "Failed to save template",
    "template.coverUploaded": "Cover image uploaded",
    "template.uploadFailed": "Failed to upload image",
    "template.blockAdded": "Block added",
    "template.blockAddFailed": "Failed to add block",
    "template.blockDeleted": "Block deleted",
    "template.blockDeleteFailed": "Failed to delete block",

    // Profile Reset
    "reset.title": "Reset Profile",
    "reset.structureTitle": "Reset Structure",
    "reset.structureDesc": "Restores block order, types, and visibility from the {orgLabel} template. Your personal content (contact info, social links, about text) will be preserved where block types match.",
    "reset.fullTitle": "Full Reset",
    "reset.fullDesc": "Replaces everything with template defaults. Cover image, theme, and colors will be restored. All custom block content will be lost. Profile picture, name, tagline, and slug are never affected.",
    "reset.confirm": "Reset",
    "reset.cancel": "Cancel",
    "reset.success": "Profile reset successfully",
    "reset.failed": "Failed to reset profile",

    // Account
    "account.title": "Account Settings",
    "account.profileInfo": "Profile Information",
    "account.email": "Email",
    "account.firstName": "First Name",
    "account.lastName": "Last Name",
    "account.save": "Save Changes",
    "account.saving": "Saving...",
    "account.saved": "Changes saved successfully",
    "account.saveFailed": "Failed to save changes",
    "account.changePassword": "Change Password",
    "account.newPassword": "New Password",
    "account.confirmPassword": "Confirm Password",
    "account.updatePassword": "Update Password",
    "account.passwordHint": "Minimum 8 characters",
    "account.passwordMin": "Password must be at least 8 characters",
    "account.passwordMismatch": "Passwords do not match",
    "account.passwordChanged": "Password updated successfully",
    "account.memberSince": "Member since",

    // Profile Editor - Tabs
    "editor.tab.general": "General",
    "editor.tab.appearance": "Appearance",
    "editor.tab.blocks": "Blocks",
    "editor.tab.gallery": "Galleries",
    "editor.tab.share": "Share",

    // Profile Editor - Top Bar
    "editor.saving": "Saving...",
    "editor.save": "Save",
    "editor.cancel": "Cancel",
    "editor.imageSource": "Upload Image",
    "editor.takePhoto": "Take Photo",
    "editor.chooseFromGallery": "Choose from Gallery",
    "editor.preview": "Preview",
    "editor.share": "Share",
    "editor.copyUrl": "Copy URL",
    "editor.qrCode": "QR Code",
    "editor.downloadVcard": "Download vCard",
    "editor.stats": "Stats",
    "editor.loading": "Loading profile...",

    // Profile Editor - General Tab
    "editor.profileType": "Profile Type",
    "editor.profileName": "Profile Name",
    "editor.profileNamePlaceholder": "My Profile",
    "editor.jobTitle": "Position / Role",
    "editor.jobTitlePlaceholder": "e.g. Sales Manager, Director",
    "editor.tagline": "Tagline",
    "editor.taglinePlaceholder": "A short tagline for your profile",
    "editor.taglineFromTemplate": "Set from {orgLabel} template",
    "editor.urlSlug": "Profile URL Slug",
    "editor.urlSlugPlaceholder": "my-profile",
    "editor.slugChangeWarning": "Changing your URL slug will break existing links!",
    "editor.slugChangeDesc": "Old URLs will redirect automatically as long as nobody else claims your old slug. If someone takes it, your old links, QR codes, and NFC cards will stop working.",
    "editor.slugChangeCancel": "Cancel",
    "editor.slugChangeConfirm": "Change & Save",
    "editor.slugChangeCurrent": "Current URL",
    "editor.slugChangeNew": "New URL",
    "editor.slugAdvisory": "Choose your slug carefully — this becomes your public profile URL.",
    "editor.tab.app": "Application",
    "editor.app.plusRequired": "PWA installation is a Plus feature. Upgrade to make your profile installable as an app.",
    "editor.app.enablePwa": "Enable Install as App",
    "editor.app.enablePwaDesc": "Allow visitors to install your profile as a standalone app on their device.",
    "editor.app.icon": "App Icon",
    "editor.app.iconDesc": "Custom icon for the installed app. Defaults to your profile photo.",
    "editor.app.uploadIcon": "Upload Custom Icon",
    "editor.app.removeIcon": "Remove Custom Icon",
    "editor.app.name": "App Name",
    "editor.app.nameDesc": "Name shown on the device home screen.",
    "editor.app.preview": "Preview",
    "editor.app.previewDesc": "How your profile will appear when installed.",
    "editor.app.notifications": "Push Notifications",
    "editor.app.notificationsDesc": "Send announcements to visitors who subscribe to your profile notifications.",
    "editor.app.subscribers": "subscribers",
    "editor.app.noSubscribers": "No subscribers yet. Visitors can subscribe from your profile page.",
    "editor.app.notifTitle": "Title",
    "editor.app.notifBody": "Message (optional)",
    "editor.app.notifImage": "Image (optional)",
    "editor.app.notifUploadImage": "Upload image",
    "editor.app.uploading": "Uploading...",
    "editor.app.notifUrl": "Link destination",
    "editor.app.notifUrlProfile": "Profile page",
    "editor.app.notifUrlBlock": "Go to block",
    "editor.app.notifUrlCustom": "Custom URL",
    "editor.app.notifSelectBlock": "Select a block",
    "editor.app.notifPinned": "Pinned — visible to all visitors regardless of when they first visited",
    "editor.app.sendNotification": "Send Notification",
    "editor.app.sending": "Sending...",
    "editor.app.notifSent": "Notification sent to {sent} of {total} subscribers",
    "editor.app.notifHistory": "Sent Notifications",
    "editor.app.notifEdit": "Edit",
    "editor.app.notifSave": "Save",
    "editor.app.notifPin": "Pin",
    "editor.app.notifUnpin": "Unpin",
    "editor.app.notifDeleteConfirm": "Delete this notification? It will be removed from the bell on your profile.",
    "editor.app.notifEditHint": "Changes show in the bell on your profile. Notifications already delivered to phones are not changed.",
    "editor.app.noNotifications": "No notifications sent yet.",
    "editor.toast.pwaIconUploaded": "App icon updated",
    "editor.profileStatus": "Profile Status",
    "editor.statusActive": "Your profile is live and visible",
    "editor.statusInactive": "Your profile is hidden from visitors",
    "editor.business": "Business",
    "editor.businessDesc": "For companies and {orgLabelPlural}",
    "editor.professional": "Professional",
    "editor.professionalDesc": "For individuals and freelancers",
    "editor.personal": "Personal",
    "editor.personalDesc": "For personal use and hobbies",

    // Profile Editor - Appearance Tab
    "editor.profileImage": "Profile Image",
    "editor.uploadProfilePhoto": "Click to upload a profile photo.",
    "editor.profilePhotoRec": "Recommended: 400x400px, JPG or PNG",
    "editor.coverImage": "Cover Image",
    "editor.uploadCoverImage": "Click to upload a cover image",
    "editor.coverImageRec": "Recommended: 1200x400px, JPG or PNG",
    "editor.welcomeScreen": "Welcome Screen",
    "editor.welcomeScreenDesc": "Show an image, flyer, or video when visitors first open your profile. They can replay it by tapping your profile picture.",
    "editor.uploadWelcomeMedia": "Upload image or video",
    "editor.welcomeMediaFormats": "JPG, PNG, GIF, MP4, WebM",
    "editor.removeWelcomeMedia": "Remove welcome media",
    "editor.welcomeShowWhen": "Auto-show:",
    "editor.welcomeAlways": "Every visit",
    "editor.welcomeOnce": "Once per device",
    "editor.welcomeScan": "Only from NFC/QR scan",
    "editor.welcomeNever": "Never (tap profile picture)",
    "editor.themeColor": "Theme Color",
    "editor.currentColor": "Current color",
    "editor.customColor": "Custom",
    "editor.themeStyle": "Theme Style",
    "editor.themePreview": "Preview",
    "editor.preview.contact": "Contact",
    "editor.preview.social": "Social",
    "editor.preview.badge": "profile",
    "editor.upload": "Upload",

    // Profile Editor - Blocks Tab
    "editor.blocksExplainer": "Blocks are the content sections of your profile — add, reorder, rename, or hide them here.",
    "editor.addBlock": "Add Block",
    "editor.noBlocks": "No blocks yet.",
    "editor.noBlocksDesc": "Click \"Add Block\" to get started.",
    "editor.deleteBlock": "Delete this block?",
    "editor.visible": "Visible",
    "editor.hidden": "Hidden",
    "editor.addContact": "Add Contact",
    "editor.addSocialLink": "Add Social Link",
    "editor.showTitle": "Show block title as header",
    "editor.noEditor": "No editor available for this block type.",

    // Profile Editor - Block Types
    "editor.blockType.contact_info": "Contact Info",
    "editor.blockType.social_links": "Social Links",
    "editor.blockType.about": "About",
    "editor.blockTitlePlaceholder": "Tap to name this section",
    "editor.blockType.custom_text": "Custom Text",
    "editor.blockType.cta_button": "CTA Button",
    "editor.blockType.website": "Website",
    "editor.blockType.header": "Header",
    "editor.blockType.location": "Location",
    "editor.blockType.contact_form": "Contact Form",
    "editor.blockType.gallery": "Gallery",
    "editor.blockType.media": "Image / Video",
    "editor.blockType.google_review": "Google Review",
    "editor.blockType.bank_info": "Bank Info",
    "editor.blockType.map": "Map",
    "editor.blockType.payment": "Payment",
    "editor.blockType.appointment": "Appointments",
    "editor.appointment.title": "Appointments",
    "editor.appointment.schedule": "Availability Schedule",
    "editor.appointment.mon": "Mon",
    "editor.appointment.tue": "Tue",
    "editor.appointment.wed": "Wed",
    "editor.appointment.thu": "Thu",
    "editor.appointment.fri": "Fri",
    "editor.appointment.sat": "Sat",
    "editor.appointment.sun": "Sun",
    "editor.appointment.addRange": "Add time range",
    "editor.appointment.services": "Service Types",
    "editor.appointment.serviceName": "Service name",
    "editor.appointment.serviceDescription": "Description (optional)",
    "editor.appointment.addService": "Add service",
    "editor.appointment.duration": "Duration",
    "editor.appointment.price": "Price",
    "editor.appointment.settings": "Settings",
    "editor.appointment.slotDuration": "Default slot",
    "editor.appointment.bufferTime": "Buffer between",
    "editor.appointment.minNotice": "Min notice",
    "editor.appointment.bookingWindow": "Booking window",
    "editor.appointment.days": "days",
    "editor.appointment.confirmationMode": "Confirmation",
    "editor.appointment.confirmAuto": "Auto-confirm",
    "editor.appointment.confirmManual": "Manual approval",
    "editor.appointment.location": "Location",
    "editor.appointment.locationNone": "Not specified",
    "editor.appointment.locationAddress": "In-person (address)",
    "editor.appointment.locationVideo": "Video call",
    "editor.appointment.locationPhone": "Phone call",
    "editor.appointment.addressPlaceholder": "Enter address",
    "editor.payment.accessToken": "Mercado Pago Access Token",
    "editor.payment.accessTokenHelp": "Your secret token starting with APP_USR-...",
    "editor.payment.howToGet": "How do I get my token?",
    "editor.payment.step1": "1. Create or sign in to your Mercado Pago account",
    "editor.payment.step2": "2. Go to Settings:",
    "editor.payment.step3": "3. Go to Integrations > Your integrations:",
    "editor.payment.step4": "4. If you don't have an application yet, click \"Create application\": enter a name, choose \"Online payments\", no e-commerce platform, and the product \"Checkout Pro\"",
    "editor.payment.step5": "5. Get your production credentials (if asked, activate them: choose your industry, enter your website — your profile link works — and accept the terms):",
    "editor.payment.step6": "6. Copy the production Access Token (starts with APP_USR-...) and paste it above. Test credentials do not charge real money",
    "editor.payment.warning": "Never share this token. It is stored securely and never shown to visitors.",
    "editor.payment.description": "Visitor Description (optional)",
    "editor.payment.descriptionDefault.en": "Send a payment quickly and securely via Mercado Pago.",
    "editor.payment.descriptionDefault.es": "Envía un pago de forma rápida y segura por Mercado Pago.",
    "editor.blockIncomplete": "Missing required content",
    "editor.payment.items": "Payment Items",
    "editor.payment.itemName": "Item name",
    "editor.payment.addItem": "Add item",
    "editor.payment.allowCustomAmount": "Allow custom amount",
    "editor.payment.installments": "Installments (months without interest)",
    "editor.payment.installmentsNone": "No installments",
    "editor.payment.installmentsMonths": "months",
    "editor.payment.buttonText": "Button Text",
    "editor.payment.buttonTextPlaceholder": "e.g. Pay Now",
    "editor.payment.configured": "Mercado Pago configured",
    "payment.pay": "Pay",
    "payment.defaultDescription": "Send a payment quickly and securely via Mercado Pago.",
    "payment.share": "Share payment link",
    "payment.customAmount": "Custom amount",
    "payment.processing": "Processing...",
    "payment.invalidAmount": "Please enter a valid amount",
    "payment.error": "Payment could not be created. Please try again.",
    "appointment.bookNow": "Book Appointment",
    "appointment.selectService": "Select a service",
    "appointment.selectDate": "Select a date",
    "appointment.selectTime": "Select a time",
    "appointment.yourInfo": "Your Information",
    "appointment.name": "Name",
    "appointment.email": "Email",
    "appointment.whatsapp": "WhatsApp (optional)",
    "appointment.notes": "Notes (optional)",
    "appointment.confirm": "Confirm Booking",
    "appointment.confirming": "Booking...",
    "appointment.success": "Appointment booked!",
    "appointment.successAuto": "Your appointment has been confirmed.",
    "appointment.successManual": "Your appointment is pending confirmation.",
    "appointment.downloadCal": "Add to Calendar",
    "appointment.myAppointments": "My Appointments",
    "appointment.noAppointments": "No appointments yet",
    "appointment.cancel": "Cancel",
    "appointment.cancelConfirm": "Cancel this appointment?",
    "appointment.cancelDesc": "This action cannot be undone. The profile owner will be notified.",
    "appointment.keepIt": "Keep it",
    "appointment.dismiss": "Dismiss",
    "appointment.cancelled": "Appointment cancelled",
    "appointment.free": "Free",
    "appointment.min": "min",
    "appointment.pending": "Pending",
    "appointment.confirmed": "Confirmed",
    "appointment.completed": "Completed",
    "appointment.status.cancelled": "Cancelled",
    "appointment.noSlots": "No available slots for this date",
    "appointment.location": "Location",
    "appointment.videoCall": "Video call",
    "appointment.phoneCall": "Phone call",
    "editor.bank.bankName": "Bank",
    "editor.bank.bankNamePlaceholder": "e.g. BBVA, Banorte, Banamex",
    "editor.bank.clabe": "CLABE",
    "editor.bank.clabePlaceholder": "18-digit interbank code",
    "editor.bank.accountNumber": "Account Number",
    "editor.bank.accountNumberPlaceholder": "Bank account number",
    "editor.bank.cardNumber": "Card Number",
    "editor.bank.cardNumberPlaceholder": "Debit card number",
    "editor.bank.beneficiary": "Beneficiary Name",
    "editor.bank.beneficiaryPlaceholder": "Full name of the account holder",
    "editor.bank.phone": "Linked Phone",
    "editor.bank.phonePlaceholder": "Phone number linked to the account",
    "editor.bank.rfc": "RFC",
    "editor.bank.rfcPlaceholder": "Tax ID (optional)",
    "editor.bank.reference": "Reference / Concept",
    "editor.bank.referencePlaceholder": "Payment reference (optional)",
    "editor.blockType.billing_info": "Billing Info",
    "editor.billing.rfc": "RFC",
    "editor.billing.rfcPlaceholder": "e.g. XAXX010101000",
    "editor.billing.businessName": "Business Name",
    "editor.billing.businessNamePlaceholder": "Legal name / Razón Social",
    "editor.billing.zipCode": "Zip Code",
    "editor.billing.zipCodePlaceholder": "e.g. 20000",
    "editor.billing.taxRegime": "Tax Regime",
    "editor.billing.taxRegimePlaceholder": "-- Select Tax Regime --",
    "editor.billing.cfdiUse": "CFDI Use",
    "editor.billing.cfdiUsePlaceholder": "-- Select CFDI Use --",
    "editor.billing.billingEmail": "Billing Email",
    "editor.billing.billingEmailPlaceholder": "Email for invoices",
    "editor.billing.rfcInvalid": "Invalid RFC format",
    "editor.billing.emailInvalid": "Invalid email format",
    "editor.map.address": "Address (optional label)",
    "editor.map.addressPlaceholder": "e.g. 123 Main St, Mexico City",
    "editor.map.lat": "Latitude",
    "editor.map.lng": "Longitude",
    "editor.map.zoom": "Zoom",
    "editor.map.hint": "Enter coordinates to pin your location on the map. You can get them from Google Maps by right-clicking any point.",
    "editor.media.remove": "Remove",
    "editor.media.upload": "Upload image or video",
    "editor.media.formats": "JPG, PNG, WebP, GIF, MP4, WebM",
    "editor.media.uploadFailed": "Upload failed",
    "editor.placeholder.placeId": "Google Place ID (e.g. ChIJN1t_tDeuEmsR...)",
    "editor.placeholder.placeIdHint": "Find your Place ID at developers.google.com/maps/documentation/places/web-service/place-id",
    "editor.selectGallery": "Select a gallery",
    "editor.noGalleriesAvailable": "No galleries yet. Create one in the Gallery tab.",
    "editor.noContactBlock": "No contact info block yet.",
    "editor.noSocialBlock": "No social links block yet.",

    // Profile Editor - Placeholders
    "editor.placeholder.label": "Label",
    "editor.placeholder.value": "Value",
    "editor.placeholder.username": "@username only",
    "editor.placeholder.url": "https://...",
    "editor.placeholder.buttonText": "Button text",
    "editor.placeholder.websiteUrl": "https://example.com",
    "editor.placeholder.aboutText": "Write about yourself or your business...",
    "editor.placeholder.content": "Content...",
    "editor.placeholder.subtitle": "Subtitle",
    "editor.placeholder.address": "Full address",
    "editor.placeholder.caption": "Caption",
    "editor.placeholder.linkUrl": "Link URL (https://...)",
    "editor.placeholder.linkText": "Link text (optional)",
    "editor.placeholder.cardCode": "Enter {cardLabel} code (e.g. ABCD1234)",
    "editor.placeholder.galleryTitle": "Gallery title...",

    // Profile Editor - Gallery Tab
    "editor.galleriesDesc": "Galleries are linked to gallery blocks. To display a gallery on your profile, add a gallery block in the Blocks tab.",
    "editor.createGallery": "Create Gallery",
    "editor.editGallery": "Edit Gallery",
    "editor.create": "Create",
    "editor.noGalleries": "No galleries yet.",
    "editor.noGalleriesDesc": "Create a gallery to start adding media.",
    "editor.deleteGallery": "Delete this gallery and all its media?",
    "editor.uploading": "Uploading...",
    "editor.storage": "Storage",
    "editor.storageAlmostFull": "Storage almost full. Delete unused media to free space.",
    "editor.storageFull": "Storage limit exceeded. Delete files or upgrade your plan.",
    "editor.fileTooBig": "This video is {size} MB. The maximum per file is {max} MB — compress it or upload a shorter clip.",
    "editor.notEnoughStorage": "This video is {size} MB but you only have {free} MB free of {max} MB on your plan. Delete files or upgrade your plan.",
    "editor.uploadLimits": "Videos up to {max} MB per file · {free} MB free on your plan",
    "editor.uploadLimitsNoStorage": "Videos up to {max} MB per file",
    "editor.uploadMedia": "Upload Media",
    "editor.takePhoto": "Take Photo",
    "editor.noMedia": "No media in this gallery yet.",

    // Profile Editor - Share Tab
    "editor.profileUrl": "Profile URL",
    "editor.referrerSource": "Tracking Source",
    "editor.referrerSourceDesc": "Select a source to generate a trackable URL. Use it to know where your visits come from.",
    "editor.referrerNone": "No tracking (direct link)",
    "editor.referrerQr": "QR Code",
    "editor.referrerNfc": "NFC {cardLabel}",
    "editor.referrerWhatsapp": "WhatsApp",
    "editor.referrerInstagram": "Instagram",
    "editor.referrerFacebook": "Facebook",
    "editor.referrerEmail": "Email",
    "editor.referrerFlyer": "Flyer / Print",
    "editor.referrerOther": "Other",
    "editor.copied": "Copied",
    "editor.copy": "Copy",
    "editor.open": "Open",
    "editor.qrScanDesc": "Scan this QR code to open the profile on any device.",
    "editor.downloadQr": "Download QR Code",
    "editor.qrShowLogo": "Show profile image in QR code",
    "editor.qrUseColor": "Use profile color in QR code",
    "editor.vcard": "vCard",
    "editor.vcardDesc": "Download a vCard file to import this profile into any contacts app.",
    "editor.downloadVcardFile": "Download vCard (.vcf)",
    "editor.nfcCards": "NFC {cardLabelPlural}",
    "editor.nfcCardsDesc": "Link NFC {cardLabelPlural} to this profile. When someone scans the {cardLabel}, they'll be taken directly here.",
    "editor.scanNfc": "Scan NFC {cardLabel} to Link",
    "editor.orEnterCode": "Or enter the {cardLabel} code manually:",
    "editor.linking": "Linking...",
    "editor.linkCard": "Link {cardLabel}",
    "editor.noCards": "No {cardLabelPlural} linked to this profile yet.",
    "editor.analytics": "Analytics",
    "editor.totalViews": "Total views",
    "editor.socialPreview": "Social Preview",
    "editor.socialPreviewDesc": "How your profile looks when shared on social media.",
    "editor.socialPreviewSeoHint": "Uses your profile image (or your cover if you have none), name and tagline. Apps may take a while to refresh a link they already cached.",
    "editor.socialPreviewUpgrade": "On your current plan, shared links show the {appName} icon and description. Upgrade to {tier} so they show your own image, name and tagline.",
    "editor.socialPreviewUpgradeBtn": "Upgrade plan",
    "editor.profile": "Profile",
    "editor.digitalProfile": "Digital Profile",

    // Profile Editor - NFC/QR Modal
    "editor.nfcTap": "NFC Tap",
    "editor.scanQr": "Scan QR",
    "editor.tapNfcCard": "Tap Your NFC {cardLabel}",
    "editor.nfcStep1": "Hold your NFC {cardLabel} or keychain near your phone",
    "editor.nfcStep2": "Your browser will open the {cardLabel} link",
    "editor.nfcStep3": "Confirm the profile and you're done!",
    "editor.qrScanCamera": "Point your camera at the QR code on the {cardLabel}",
    "editor.close": "Close",
    "editor.downloadPng": "Download PNG",

    // Profile Editor - Crop Modal
    "editor.zoom": "Zoom",
    "editor.cropCancel": "Cancel",
    "editor.cropUpload": "Crop & Upload",

    // Profile Editor - Toast Messages
    "editor.toast.profileSaved": "Profile saved successfully",
    "editor.toast.emptyFields": "Some contact or social fields are empty",
    "editor.hint.blockMirrorBefore": "Quick edit — to",
    "editor.hint.goToBlock": "manage block",
    "editor.hint.blockMirrorAfter": "(reorder, rename or hide) use the Blocks tab",
    "editor.toast.profileSaveFailed": "Failed to save profile",
    "editor.toast.profileImageUploaded": "Profile image uploaded",
    "editor.toast.coverImageUploaded": "Cover image uploaded",
    "editor.toast.uploadFailed": "Failed to upload image",
    "editor.toast.uploadCancelled": "Upload cancelled",
    "editor.toast.urlCopied": "URL copied to clipboard",
    "editor.toast.urlCopyFailed": "Failed to copy URL",
    "editor.toast.blockAdded": "{label} block added",
    "editor.toast.blockAddFailed": "Failed to add block",
    "editor.toast.tierRequired": "This feature requires a Plus subscription",
    "editor.plusBlockWarning": "This block requires a Plus subscription. It won't be visible to visitors until you upgrade.",
    "editor.plusBlocksWarning": "Blocks marked with PLUS won't be displayed publicly until you upgrade your subscription.",
    "editor.toast.blockUpdateFailed": "Failed to update block",
    "editor.toast.blockDeleted": "Block deleted",
    "editor.toast.blockDeleteFailed": "Failed to delete block",
    "editor.toast.reorderFailed": "Failed to reorder blocks",
    "editor.toast.contactAddFailed": "Failed to add contact",
    "editor.toast.contactUpdateFailed": "Failed to update contact",
    "editor.toast.contactDeleteFailed": "Failed to delete contact",
    "editor.toast.socialAddFailed": "Failed to add social link",
    "editor.toast.socialUpdateFailed": "Failed to update social link",
    "editor.toast.socialDeleteFailed": "Failed to delete social link",
    "editor.toast.galleryCreated": "Gallery created",
    "editor.toast.galleryCreateFailed": "Failed to create gallery",
    "editor.toast.galleryUpdateFailed": "Failed to update gallery",
    "editor.toast.galleryDeleted": "Gallery deleted",
    "editor.toast.galleryDeleteFailed": "Failed to delete gallery",
    "editor.toast.mediaUploaded": "Media uploaded",
    "editor.toast.mediaUploadFailed": "Failed to upload media",
    "editor.deleteVideoConfirm": "Delete this video? The file is removed permanently and frees up its space on your plan.",
    "editor.deleteMediaConfirm": "Delete this photo? The file is removed permanently and frees up its space on your plan.",
    "editor.toast.uploadInterrupted": "The upload was interrupted. Check your connection, or the file may be over {max} MB.",
    "editor.toast.mediaDeleted": "Media deleted",
    "editor.toast.mediaDeleteFailed": "Failed to delete media",
    "editor.toast.cardLinked": "{cardLabel} linked successfully",
    "editor.toast.cardLinkFailed": "Failed to link {cardLabel}",
    "editor.toast.cardUnlinked": "{cardLabel} unlinked",
    "editor.toast.cardUnlinkFailed": "Failed to unlink {cardLabel}",
    "editor.toast.qrNotSupported": "QR scanning is not supported on this browser. Use your phone's camera app instead.",
    "editor.toast.cameraFailed": "Could not access camera. Please allow camera permissions.",

    // Profile Editor - Media Types
    "editor.mediaType.image": "Image",
    "editor.mediaType.video": "Video",
    "editor.mediaType.image_360": "360 Image",

    // Profile Editor - Theme Names
    "editor.theme.modern": "Modern",
    "editor.theme.classic": "Classic",
    "editor.theme.minimal": "Minimal",
    "editor.theme.bold": "Bold",
    "editor.theme.pro": "Pro",
    "editor.theme.instagram": "Instagram",
    "editor.theme.instagramDark": "Instagram Dark",

    // Stats Page
    "stats.backToProfile": "Back to Profile",
    "stats.title": "Stats",
    "stats.subtitle": "Activity analytics",
    "stats.howItWorks": "How are stats counted?",
    "stats.rule1": "Your own visits are not counted — stats only track activity from other people.",
    "stats.rule2": "Every action from a visitor is counted individually. If the same person visits 10 times, it counts as 10 views.",
    "stats.rule3": "\"Unique\" counts show how many different devices interacted, helping you distinguish 100 visits from 5 people vs. 100 people.",
    "stats.rule4": "Card taps track how many times your NFC card or QR code was scanned.",
    "stats.allEvents": "All Events",
    "stats.views": "Views",
    "stats.contactClicks": "Contact Clicks",
    "stats.socialClicks": "Social Clicks",
    "stats.linkClicks": "Link Clicks",
    "stats.shares": "Shares",
    "stats.vcardDownloads": "vCard Downloads",
    "stats.qrScans": "QR Scans",
    "stats.days": "{n} days",
    "stats.last": "Last {n} days",
    "stats.total": "total",
    "stats.unique": "unique",
    "stats.cardTaps": "Card Taps",
    "stats.noActivity": "No activity in this period",
    "stats.recentEvents": "Recent Events",
    "stats.noEvents": "No events recorded yet",
    "stats.referrers": "Traffic Sources",
    "stats.referrerDirect": "Direct",
    "stats.referrerQr": "QR Code",
    "stats.referrerNfc": "NFC {cardLabel}",
    "stats.referrerWhatsapp": "WhatsApp",
    "stats.referrerInstagram": "Instagram",
    "stats.referrerFacebook": "Facebook",
    "stats.referrerEmail": "Email",
    "stats.referrerFlyer": "Flyer / Print",
    "stats.referrerShare": "Share Button",
    "stats.referrerOther": "Other",
    "stats.referrerVcard": "vCard",

    "editor.tab.stats": "Stats",
    // CRM / Leads
    "editor.tab.crm": "CRM",
    "crm.title": "Leads",
    "crm.subtitle": "People who contacted you through your profile",
    "crm.noLeads": "No leads yet. Add a Contact Form block to your profile to start collecting leads.",
    "crm.statusNew": "New",
    "crm.statusContacted": "Contacted",
    "crm.statusConverted": "Converted",
    "crm.statusArchived": "Archived",
    "crm.allStatuses": "All",
    "crm.notes": "Notes",
    "crm.notesPlaceholder": "Add private notes...",
    "crm.source": "Source",
    "crm.delete": "Delete",
    "crm.deleteConfirm": "Delete this lead?",
    "crm.deleteConfirmBtn": "Delete",
    "crm.cancel": "Cancel",
    "crm.exportCsv": "Export CSV",
    "crm.pushNotifications": "Push Notifications",
    "crm.pushEnabled": "Notifications enabled",
    "crm.pushEnable": "Enable notifications",
    "crm.pushTooltip": "Receive push notifications for new leads, reviews and appointments",
    "crm.pushDisable": "Disable",
    "crm.pushNotSupported": "Push notifications are not supported in this browser",
    "crm.leadsCount": "{count} leads",
    "crm.appointments": "Appointments",
    "crm.appointmentsSubtitle": "Manage your appointment bookings",
    "crm.pushNotifications": "Push",
    "crm.noAppointments": "No appointments yet",
    "crm.apptPending": "Pending",
    "crm.apptConfirmed": "Confirmed",
    "crm.apptCancelled": "Cancelled",
    "crm.apptCompleted": "Completed",
    "crm.whatsapp": "WhatsApp",
    "crm.call": "Call",
    "crm.downloadIcal": "Download calendar file",

    // Contact Form Block
    "contactForm.title": "Contact Form",
    "contactForm.nameLabel": "Name",
    "contactForm.namePlaceholder": "Your name",
    "contactForm.emailLabel": "Email",
    "contactForm.emailPlaceholder": "your@email.com",
    "contactForm.whatsappLabel": "WhatsApp",
    "contactForm.whatsappPlaceholder": "+1 234 567 8900",
    "contactForm.messageLabel": "Message",
    "contactForm.messagePlaceholder": "How can we help you?",
    "contactForm.submit": "Send",
    "contactForm.sending": "Sending...",
    "contactForm.success": "Message sent successfully!",
    "contactForm.error": "Could not send message. Please try again.",
    "contactForm.alreadySent": "You've already sent a message. Thank you!",
    "contactForm.edit": "Edit my info",
    "contactForm.update": "Update",
    "contactForm.cancel": "Cancel",
    "contactForm.showEmail": "Show email field",
    "contactForm.showWhatsapp": "Show WhatsApp field",
    "contactForm.showMessage": "Show message field",
    "contactForm.requireEmail": "Require email",
    "contactForm.requireWhatsapp": "Require WhatsApp",
    "contactForm.buttonText": "Submit button text",
    "contactForm.successMessage": "Success message",

    // Google Review
    "review.title": "Leave a Review",
    "review.tapToRate": "Tap a star to rate your experience",
    "review.thanks": "Thank you for your feedback!",
    "review.openGoogle": "Complete your review on Google",
    "review.star1": "Poor",
    "review.star2": "Fair",
    "review.star3": "Good",
    "review.star4": "Very Good",
    "review.star5": "Excellent",
    "review.feedbackPrompt": "We'd love to hear how we can improve",
    "review.feedbackPlaceholder": "Tell us about your experience...",
    "review.sendFeedback": "Send Feedback",
    "review.sending": "Sending...",
    "review.alreadyReviewed": "You've already submitted a review. Thank you!",

    // Reviews Tab (Editor)
    "editor.tab.reviews": "Reviews",
    "reviews.totalReviews": "Total Reviews",
    "reviews.avgRating": "Average",
    "reviews.positive": "Positive (4-5)",
    "reviews.needsWork": "Needs Work (1-3)",
    "reviews.breakdown": "Rating Breakdown",
    "reviews.noReviews": "No reviews yet",
    "reviews.noReviewsDesc": "Reviews will appear here when visitors rate your profile.",
    "reviews.redirectedToGoogle": "Redirected to Google Reviews",
    "reviews.periodAll": "All Time",
    "reviews.periodToday": "Today",
    "reviews.periodWeek": "This Week",
    "reviews.periodMonth": "This Month",
    "reviews.period3Months": "Last 3 Months",
    "reviews.period6Months": "Last 6 Months",
    "reviews.periodYear": "Last Year",
    "reviews.allStars": "All",

    // Cards
    "cards.title": "My {cardLabelPlural}",
    "cards.subtitle": "{count} {cardLabel}(s) linked to your account",
    "cards.noCards": "No {cardLabelPlural} yet",
    "cards.noCardsDesc": "Link a {cardLabel} to one of your profiles and it will appear here.",
    "cards.copyUrl": "Copy URL",
    "cards.scans": "scans",
    "cards.unique": "unique",
    "cards.labelPlaceholder": "e.g. Business card, Event card...",
    "cards.noLabel": "No label",
    "cards.notLinked": "Not linked to any profile",
    "cards.change": "Change",
    "cards.unlink": "Unlink",
    "cards.linkProfile": "Link to profile",
    "cards.selectProfile": "Select Profile",
    "cards.linkCardTo": "Choose which profile {cardLabel} {code} should link to:",
    "cards.noProfiles": "No profiles available",

    // Subscriptions
    "subs.title": "Subscriptions",
    "subs.subtitle": "View your profile plans and subscription status",
    "subs.active": "Active Subscriptions",
    "subs.freeTier": "Free Plan",
    "subs.from": "From",
    "subs.until": "Until",
    "subs.editProfile": "Edit Profile",
    "subs.viewProfile": "View Profile",
    "subs.allPremium": "All your profiles have an active subscription!",
    "subs.upgradeHint": "Upgrade this profile to unlock all features",
    "subs.upgrade": "Upgrade",
    "subs.paymentSuccess": "Payment successful! Your subscription is now active.",
    "subs.paymentFailure": "Payment failed. Please try again.",
    "subs.paymentPending": "Payment is being processed. Your subscription will be activated shortly.",
    "subs.history": "History",
    "subs.expired": "Expired",
    "subs.activeLabel": "Active",
    "subs.daysLeft": "days left",

    // Upgrade / Checkout
    "upgrade.back": "Back to subscriptions",
    "upgrade.title": "Upgrade",
    "upgrade.subtitle": "Unlock premium features for your profile",
    "upgrade.allUpgraded": "All profiles upgraded!",
    "upgrade.allUpgradedDesc": "All your profiles already have the selected tier or higher.",
    "upgrade.selectTier": "1. Select tier",
    "upgrade.selectProfile": "2. Select profile",
    "upgrade.selectPlan": "3. Choose plan",
    "upgrade.paymentMethod": "4. Payment method",
    "upgrade.month": "month",
    "upgrade.months": "months",
    "upgrade.mo": "mo",
    "upgrade.method.credit_card": "Credit / Debit Card",
    "upgrade.method.credit_card_desc": "Visa, Mastercard, AMEX. Supports automatic renewal.",
    "upgrade.method.spei": "SPEI Transfer",
    "upgrade.method.spei_desc": "Bank transfer. One-time payment, manual renewal.",
    "upgrade.method.cash": "Cash (OXXO / Convenience Store)",
    "upgrade.method.cash_desc": "Pay at any OXXO. One-time payment, manual renewal.",
    "upgrade.autoRenew": "Auto-renew subscription",
    "upgrade.autoRenewDesc": "Your card will be charged automatically each period",
    "upgrade.total": "Total",
    "upgrade.pay": "Pay now",
    "upgrade.processing": "Processing...",
    "upgrade.secure": "Secure payment powered by Mercado Pago",
    "upgrade.cardDetails": "Enter card details",
    "upgrade.cardNumber": "Card number",
    "upgrade.expiration": "Expiration",
    "upgrade.cvv": "CVV",
    "upgrade.cardholderName": "Cardholder name",
    "upgrade.email": "Email",
    "upgrade.docType": "Doc type",
    "upgrade.docNumber": "Doc number",
    "upgrade.issuer": "Issuing bank",
    "upgrade.installments": "Installments",
    "upgrade.paymentError": "There was a problem with your payment",
    "upgrade.rejectedGeneric": "Your payment was declined. Please try a different card or payment method.",
    "upgrade.rejectedDebit": "Debit cards are not supported for this payment. Please use a credit card instead.",

    // Public Profile
    "public.loading": "Loading profile...",
    "public.blockTitle.location": "Location",
    "public.blockTitle.about": "About",
    "public.blockTitle.contact": "Contact",
    "public.blockTitle.social": "Social",
    "public.blockTitle.learnMore": "Learn More",
    "public.blockTitle.website": "Website",
    "public.bank.title": "Bank Information",
    "public.bank.bankName": "Bank",
    "public.bank.clabe": "CLABE",
    "public.bank.accountNumber": "Account Number",
    "public.bank.cardNumber": "Card Number",
    "public.bank.beneficiary": "Beneficiary",
    "public.bank.phone": "Linked Phone",
    "public.bank.rfc": "RFC",
    "public.bank.reference": "Reference",
    "public.bank.copy": "Copy",
    "public.bank.share": "Share Bank Info",
    "public.billing.title": "Billing Information",
    "public.billing.rfc": "RFC",
    "public.billing.businessName": "Business Name",
    "public.billing.zipCode": "Zip Code",
    "public.billing.taxRegime": "Tax Regime",
    "public.billing.cfdiUse": "CFDI Use",
    "public.billing.billingEmail": "Billing Email",
    "public.billing.share": "Share Billing Info",
    "public.notFoundTitle": "Profile Not Found",
    "public.notFoundDesc": "The profile you're looking for doesn't exist or may have been removed.",
    "public.pwaDisabledTitle": "Application Not Available",
    "public.pwaDisabledDesc": "This application is no longer available. You can wait until the owner enables it again, or remove it from your device.",
    "public.pwaDisabledHowTo": "To remove this application",
    "public.pwaDisabledAndroid1": "Long-press the app icon on your home screen",
    "public.pwaDisabledAndroid2": "Tap \"Uninstall\" or drag to \"Remove\"",
    "public.pwaDisabledIos1": "Long-press the app icon on your home screen",
    "public.pwaDisabledIos2": "Tap \"Remove Bookmark\" or \"Delete Bookmark\"",
    "public.pwaDisabledIos3": "Tap \"Delete\" to confirm",
    "public.pwaDisabledCopy": "To view the profile in a browser, copy this URL:",
    "public.pwaDisabledCopyBtn": "Copy",
    "public.share": "Share",
    "public.shareProfile": "Share Profile",
    "public.viewPhoto": "View photo",
    "public.viewWelcome": "View welcome screen",
    "public.cancel": "Cancel",
    "public.dontShowAgain": "Don't show again",
    "public.viewProfile": "View profile",
    "public.unmute": "Tap for sound",
    "public.copied": "Copied!",
    "public.qrCode": "QR Code",
    "public.save": "Save",
    "public.saveContact": "Save Contact",
    "public.installApp": "Install {name}",
    "public.installAppDesc": "Add this profile to your home screen for quick access.",
    "public.iosInstallDesc": "2 easy steps using Safari's bottom bar:",
    "public.installButton": "Install",
    "public.iosInstallHint": "Tap the share button, then \"Add to Home Screen\".",
    "public.iosStep1": "Tap the Share button in Safari",
    "public.iosStep2": "Tap \"Add to Home Screen\"",
    "public.iosArrowText_before": "Look for the",
    "public.iosArrowText_after": "button in Safari's bar",
    "public.iosArrowStep2_before": "Then tap",
    "public.iosArrowStep2_after": "Add to Home Screen",
    "public.openInMaps": "Open in Maps",
    "public.notifications": "Notifications",
    "public.noNotifications": "No notifications yet",
    "public.enableNotifications": "Get notified",
    "public.notificationsEnabled": "Notifications on",
    "public.disableNotifications": "Turn off",
    "public.dismiss": "Dismiss",
    "public.dismissAll": "Clear all",
    "public.notifPromptTitle": "Get updates from {name}",
    "public.notifPromptDesc": "Be the first to know when there's something new.",
    "public.notifPromptAllow": "Enable",
    "public.notifPromptDismiss": "Not now",
    "preview.backToEditor": "Go back",
    "preview.previewMode": "Preview mode",
    "public.scanQrCode": "Scan QR Code",
    "public.shareInstantly": "Share this profile instantly",
    "public.sections": "sections",
    "public.photos": "photos",

    // Common
    "common.loading": "Loading...",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.save": "Save",
    "common.language": "Language",
    "common.english": "English",
    "common.spanish": "Spanish",

    // Card claim flow
    "card.welcomeTitle": "Your New {cardLabel}!",
    "card.welcomeSubtitle": "Set up your digital profile in seconds.",
    "card.welcomeCode": "{cardLabel} {code}",
    "card.createAccount": "Create Account",
    "card.iHaveAccount": "I already have an account",
    "card.linkTitle": "Link This {cardLabel}",
    "card.linkSubtitle": "{cardLabel} {code} is not linked yet.",
    "card.linkTo": "Link this {cardLabel} to:",
    "card.nameYourProfile": "What should we call your profile?",
    "card.noProfiles": "You don't have any profiles yet. One will be created for you.",
    "card.confirmLink": "Confirm & Link {cardLabel}",
    "card.linking": "Linking...",
    "card.linked": "{cardLabel} Linked!",
    "card.linkedDesc": "This {cardLabel} is now linked to {name}. Anyone who scans it will see this profile.",
    "card.goToEditor": "Customize Your Profile",
    "card.linkFailed": "Failed to link {cardLabel}",
    "card.settingUp": "Setting up your {cardLabel}...",
    "card.notAvailable": "{cardLabel} not available.",
    "card.tooManyRequests": "Too many requests. Please try again in a moment.",
    "card.errorTitle": "{cardLabel} Not Available",
    "card.defaultProfileName": "My Profile",
    "card.createNewProfile": "Create new profile",
    "card.createAndLink": "Create Profile & Link {cardLabel}",
    "card.newProfileName": "New profile name",
    "card.useExisting": "Use an existing profile instead",
    "card.maxReached": "Profile limit reached ({max} max)",
    "card.selectProfile": "Please select a profile",
    "card.typePersonal": "Personal",
    "card.typeBusiness": "Business",
    "card.typeProfessional": "Professional",

    // PWA
    "pwa.installTitle": "Install {appName}",
    "pwa.installDesc": "Get your new leads and appointments instantly on your phone",
    "pwa.iosInstructions": "Tap Share, then \"Add to Home Screen\" (needed for notifications on iPhone)",
    "pwa.installButton": "Install",

    // Distributor portal
    "distributor.login_title": "Distributor Portal",
    "distributor.logout": "Logout",
    "distributor.total": "Total",
    "distributor.available": "Available",
    "distributor.sold": "Sold",
    "distributor.claimed": "Claimed",
    "distributor.scan": "Scan",
    "distributor.search": "Search by code or label...",
    "distributor.all": "All",
    "distributor.no_match": "No matching cards",
    "distributor.no_cards": "No cards assigned yet",
    "distributor.scan_title": "Scan a Card",
    "distributor.scan_desc": "Choose how to read the card.",
    "distributor.scan_qr": "Scan QR Code",
    "distributor.scan_qr_desc": "Use camera to read a QR code",
    "distributor.scan_nfc": "Read NFC Tag",
    "distributor.scan_nfc_desc": "Tap an NFC tag to read it",
    "distributor.scan_qr_hint": "Point your camera at the card's QR code.",
    "distributor.scan_nfc_reading": "Reading NFC...",
    "distributor.scan_nfc_hint": "Hold an NFC tag near your device.",
    "distributor.card_found": "Card Found",
    "distributor.card_detail": "Card Details",
    "distributor.close": "Close",
    "distributor.code": "Code",
    "distributor.label": "Label",
    "distributor.status_label": "Status",
    "distributor.linked_profile": "Linked Profile",
    "distributor.sale_price": "Sale Price (optional)",
    "distributor.sale_price_placeholder": "0.00",
    "distributor.mark_sold": "Mark as Sold",
    "distributor.already_sold": "This card has already been sold or claimed.",
    "distributor.scan_another": "Scan Another",
    "distributor.not_found": "Card Not Found",
    "distributor.not_found_desc": "This card is not registered in the system.",
    "distributor.not_yours": "Not Your Card",
    "distributor.not_yours_desc": "This card is not assigned to you.",
    "distributor.sold_success": "Marked as Sold!",
    "distributor.sold_success_desc": "has been marked as sold.",
    "distributor.error": "Error",
    "distributor.try_again": "Try Again",
    "distributor.status.created": "Created",
    "distributor.status.printed": "Printed",
    "distributor.status.ready": "Ready",
    "distributor.status.activated": "Activated",
    "distributor.status.sold": "Sold",
    "distributor.status.claimed": "Claimed",
    "distributor.history": "History",
    "distributor.history_show_all": "Show all ({count})",
    "distributor.history_show_less": "Show less",
    "distributor.event.created": "Card created",
    "distributor.event.assigned": "Assigned to you",
    "distributor.event.sold": "Marked as sold",
    "distributor.event.claimed": "Claimed by user",
    "distributor.event.status_change": "Status changed",
    "distributor.event.activated": "Activated by admin",
  },

  es: {
    // Login
    "login.title": "Inicia sesión en tu cuenta",
    "login.email": "Correo electrónico",
    "login.password": "Contraseña",
    "login.submit": "Iniciar Sesión",
    "login.submitting": "Iniciando sesión...",
    "login.noAccount": "¿No tienes una cuenta?",
    "login.signUp": "Regístrate",
    "login.failed": "Error al iniciar sesión. Inténtalo de nuevo.",
    "login.forgotPassword": "¿Olvidaste tu contraseña?",
    "login.forgotTitle": "Restablecer contraseña",
    "login.forgotDesc": "Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.",
    "login.forgotSubmit": "Enviar Enlace",
    "login.forgotSubmitting": "Enviando...",
    "login.forgotSuccess": "Si ese correo está registrado, se ha enviado un enlace. Revisa tu bandeja de entrada.",
    "login.forgotBack": "Volver al inicio de sesión",
    "login.resetTitle": "Nueva contraseña",
    "login.resetDesc": "Ingresa tu nueva contraseña.",
    "login.newPassword": "Nueva Contraseña",
    "login.confirmPassword": "Confirmar Contraseña",
    "login.resetSubmit": "Restablecer Contraseña",
    "login.resetSubmitting": "Restableciendo...",
    "login.resetSuccess": "¡Contraseña actualizada! Ya puedes iniciar sesión.",
    "login.resetPasswordMismatch": "Las contraseñas no coinciden",
    "login.resetInvalidToken": "Enlace inválido o expirado.",

    // Register
    "register.title": "Crea tu cuenta",
    "register.firstName": "Nombre",
    "register.lastName": "Apellido",
    "register.email": "Correo electrónico",
    "register.password": "Contraseña",
    "register.submit": "Crear Cuenta",
    "register.submitting": "Creando cuenta...",
    "register.hasAccount": "¿Ya tienes una cuenta?",
    "register.signIn": "Inicia sesión",
    "register.failed": "Error al registrarse. Inténtalo de nuevo.",

    // Dashboard
    "dashboard.title": "Mis Perfiles",
    "dashboard.profileCount": "{count} de {max} perfil",
    "dashboard.profileCountPlural": "{count} de {max} perfiles",
    "dashboard.createProfile": "Crear Perfil",
    "dashboard.createFirst": "Crea Tu Primer Perfil",
    "dashboard.limitReached": "Límite de perfiles alcanzado ({count}/{max})",
    "dashboard.slotsExplainNoCards": "Tienes {free} perfil gratuito incluido. Registra un {cardLabel} para obtener un perfil adicional por cada uno.",
    "dashboard.slotsExplainWithCards": "Tienes {free} perfil gratuito + {cards} de tus {cardLabelPlural} = {total} perfiles disponibles.",
    "dashboard.noProfiles": "Aún no hay perfiles",
    "dashboard.noProfilesDesc": "Crea tu primer perfil digital para empezar a compartir tu marca profesional, personal o de negocio.",
    "dashboard.views": "vistas",
    "dashboard.subscriptionUntil": "Plus hasta",
    "dashboard.freeTier": "Plan gratuito — actualiza para desbloquear todas las funciones",
    "dashboard.edit": "Editar",
    "dashboard.view": "Ver",
    "dashboard.stats": "Estadísticas",
    "dashboard.upgrade": "Mejorar",
    "dashboard.deleteProfile": "Eliminar Perfil",
    "dashboard.deleteConfirm": "¿Estás seguro de que deseas eliminar",
    "dashboard.deleteWarn": "Esta acción no se puede deshacer.",
    "dashboard.cancel": "Cancelar",
    "dashboard.delete": "Eliminar",
    "dashboard.createNew": "Crear Nuevo Perfil",
    "dashboard.profileName": "Nombre del Perfil",
    "dashboard.profileType": "Tipo de Perfil",
    "dashboard.tagline": "Eslogan",
    "dashboard.themeColor": "Color del tema",
    "dashboard.customColor": "Personalizado",
    "dashboard.business": "Negocio",
    "dashboard.professional": "Profesional",
    "dashboard.personal": "Personal",
    "dashboard.organization": "{orgLabel}",
    "dashboard.creating": "Creando...",
    "dashboard.orgProfileCount": "{count} de {max} perfil",
    "dashboard.orgProfileCountPlural": "{count} de {max} perfiles",
    "dashboard.orgLimitReached": "Límite alcanzado ({count}/{max})",
    "dashboard.manageOrg": "Administrar",
    "dashboard.noOrgProfiles": "Aún no hay perfiles en {orgArticle} {orgLabel}",

    // Layout
    "layout.profiles": "Perfiles",
    "layout.cards": "{cardLabelPlural}",
    "layout.subscriptions": "Suscripciones",
    "layout.organizations": "{orgLabelPlural}",
    "layout.account": "Cuenta",
    "layout.installApp": "Instalar app",
    "layout.logout": "Cerrar Sesión",

    // Organizations
    "orgs.title": "{orgLabelPlural}",
    "orgs.create": "Crear {orgLabel}",
    "orgs.creating": "Creando...",
    "orgs.createFailed": "Error al crear {orgLabel}",
    "orgs.name": "Nombre",
    "orgs.namePlaceholder": "ej. Mi Empresa",
    "orgs.description": "Descripción",
    "orgs.descriptionPlaceholder": "¿A qué se dedica {orgArticle} {orgLabel}?",
    "orgs.cancel": "Cancelar",
    "orgs.save": "Guardar",
    "orgs.delete": "Eliminar",
    "orgs.deleteFailed": "Error al eliminar {orgLabel}",
    "orgs.deleteConfirmTitle": "Eliminar {orgLabel}",
    "orgs.deleteConfirmDesc": "Esta acción no se puede deshacer. {orgLabel} y su plantilla serán eliminados permanentemente.",
    "orgs.noOrgs": "Aún no hay {orgLabelPlural}.",
    "orgs.noOrgsDesc": "Crea {orgArticleUn} {orgLabel} para gestionar perfiles bajo una marca.",
    "orgs.profile": "perfil",
    "orgs.profiles": "perfiles",
    "orgs.backToOrgs": "Volver a {orgLabelPlural}",
    "orgs.editOrg": "Editar {orgLabel}",
    "orgs.template": "Plantilla Base",
    "orgs.orgProfiles": "Perfiles",
    "orgs.createProfile": "Crear Perfil",
    "orgs.createProfileDesc": "Este perfil se creará a partir de la plantilla base de {orgLabel}.",
    "orgs.createProfileFailed": "Error al crear el perfil",
    "orgs.profileName": "Nombre del Perfil",
    "orgs.jobTitle": "Puesto / Cargo",
    "orgs.noProfiles": "Aún no hay perfiles.",
    "orgs.noProfilesDesc": "Crea un perfil para comenzar.",
    "orgs.deleteProfileTitle": "Eliminar Perfil",
    "orgs.deleteProfileDesc": "Este perfil será eliminado permanentemente.",

    // Template Editor
    "template.title": "Plantilla Base",
    "template.description": "Define el aspecto y la estructura predeterminada para los nuevos perfiles de {orgArticle} {orgLabel}.",
    "template.tagline": "Eslogan",
    "template.taglineDesc": "Compartido en todos los perfiles de {orgArticle} {orgLabel} (ej. eslogan de la empresa).",
    "template.taglinePlaceholder": "ej. Innovación digital a tu medida",
    "template.back": "Volver",
    "template.coverImage": "Imagen de Portada",
    "template.uploadCover": "Subir imagen de portada",
    "template.themeColor": "Color del Tema",
    "template.themeStyle": "Estilo del Tema",
    "template.blocks": "Bloques Predeterminados",
    "template.blocksDesc": "Estos bloques se crearán automáticamente cuando se agregue un nuevo perfil a {orgArticle} {orgLabel}.",
    "template.addBlock": "Agregar Bloque",
    "template.noBlocks": "No hay bloques definidos. Agrega bloques para establecer la estructura predeterminada.",
    "template.saved": "Plantilla guardada",
    "template.saveFailed": "Error al guardar la plantilla",
    "template.coverUploaded": "Imagen de portada subida",
    "template.uploadFailed": "Error al subir la imagen",
    "template.blockAdded": "Bloque agregado",
    "template.blockAddFailed": "Error al agregar bloque",
    "template.blockDeleted": "Bloque eliminado",
    "template.blockDeleteFailed": "Error al eliminar bloque",

    // Profile Reset
    "reset.title": "Restablecer Perfil",
    "reset.structureTitle": "Restablecer Estructura",
    "reset.structureDesc": "Restaura el orden, tipo y visibilidad de los bloques desde la plantilla de {orgLabel}. Tu contenido personal (información de contacto, redes sociales, texto) se conservará donde los tipos de bloque coincidan.",
    "reset.fullTitle": "Restablecimiento Completo",
    "reset.fullDesc": "Reemplaza todo con los valores predeterminados de la plantilla. La imagen de portada, tema y colores serán restaurados. Todo el contenido personalizado de los bloques se perderá. La foto de perfil, nombre, eslogan y slug nunca se ven afectados.",
    "reset.confirm": "Restablecer",
    "reset.cancel": "Cancelar",
    "reset.success": "Perfil restablecido correctamente",
    "reset.failed": "Error al restablecer el perfil",

    // Account
    "account.title": "Configuración de Cuenta",
    "account.profileInfo": "Información Personal",
    "account.email": "Correo Electrónico",
    "account.firstName": "Nombre",
    "account.lastName": "Apellido",
    "account.save": "Guardar Cambios",
    "account.saving": "Guardando...",
    "account.saved": "Cambios guardados correctamente",
    "account.saveFailed": "Error al guardar los cambios",
    "account.changePassword": "Cambiar Contraseña",
    "account.newPassword": "Nueva Contraseña",
    "account.confirmPassword": "Confirmar Contraseña",
    "account.updatePassword": "Actualizar Contraseña",
    "account.passwordHint": "Mínimo 8 caracteres",
    "account.passwordMin": "La contraseña debe tener al menos 8 caracteres",
    "account.passwordMismatch": "Las contraseñas no coinciden",
    "account.passwordChanged": "Contraseña actualizada correctamente",
    "account.memberSince": "Miembro desde",

    // Profile Editor - Tabs
    "editor.tab.general": "General",
    "editor.tab.appearance": "Apariencia",
    "editor.tab.blocks": "Bloques",
    "editor.tab.gallery": "Galerías",
    "editor.tab.share": "Compartir",

    // Profile Editor - Top Bar
    "editor.saving": "Guardando...",
    "editor.save": "Guardar",
    "editor.cancel": "Cancelar",
    "editor.imageSource": "Subir Imagen",
    "editor.takePhoto": "Tomar Foto",
    "editor.chooseFromGallery": "Elegir de Galer\u00eda",
    "editor.preview": "Vista previa",
    "editor.share": "Compartir",
    "editor.copyUrl": "Copiar URL",
    "editor.qrCode": "Código QR",
    "editor.downloadVcard": "Descargar vCard",
    "editor.stats": "Estadísticas",
    "editor.loading": "Cargando perfil...",

    // Profile Editor - General Tab
    "editor.profileType": "Tipo de Perfil",
    "editor.profileName": "Nombre del Perfil",
    "editor.profileNamePlaceholder": "Mi Perfil",
    "editor.jobTitle": "Puesto / Cargo",
    "editor.jobTitlePlaceholder": "ej. Gerente de Ventas, Director",
    "editor.tagline": "Eslogan",
    "editor.taglinePlaceholder": "Un breve eslogan para tu perfil",
    "editor.taglineFromTemplate": "Definido en la plantilla de {orgLabel}",
    "editor.urlSlug": "URL del Perfil",
    "editor.urlSlugPlaceholder": "mi-perfil",
    "editor.slugChangeWarning": "Cambiar tu slug romperá los enlaces existentes!",
    "editor.slugChangeDesc": "Las URLs antiguas redirigirán automáticamente mientras nadie más reclame tu slug anterior. Si alguien lo toma, tus enlaces, códigos QR y tarjetas NFC dejarán de funcionar.",
    "editor.slugChangeCancel": "Cancelar",
    "editor.slugChangeConfirm": "Cambiar y Guardar",
    "editor.slugChangeCurrent": "URL actual",
    "editor.slugChangeNew": "Nueva URL",
    "editor.slugAdvisory": "Elige tu slug con cuidado — se convierte en la URL pública de tu perfil.",
    "editor.tab.app": "Aplicación",
    "editor.app.plusRequired": "La instalación como app es una función Plus. Mejora tu plan para que tu perfil sea instalable como aplicación.",
    "editor.app.enablePwa": "Habilitar Instalar como App",
    "editor.app.enablePwaDesc": "Permite a los visitantes instalar tu perfil como una aplicación independiente en su dispositivo.",
    "editor.app.icon": "Ícono de App",
    "editor.app.iconDesc": "Ícono personalizado para la app instalada. Por defecto usa tu foto de perfil.",
    "editor.app.uploadIcon": "Subir Ícono Personalizado",
    "editor.app.removeIcon": "Eliminar Ícono Personalizado",
    "editor.app.name": "Nombre de App",
    "editor.app.nameDesc": "Nombre que se muestra en la pantalla de inicio del dispositivo.",
    "editor.app.preview": "Vista Previa",
    "editor.app.previewDesc": "Cómo se verá tu perfil cuando esté instalado.",
    "editor.app.notifications": "Notificaciones Push",
    "editor.app.notificationsDesc": "Envía anuncios a los visitantes que se suscriban a las notificaciones de tu perfil.",
    "editor.app.subscribers": "suscriptores",
    "editor.app.noSubscribers": "Aún no hay suscriptores. Los visitantes pueden suscribirse desde tu página de perfil.",
    "editor.app.notifTitle": "Título",
    "editor.app.notifBody": "Mensaje (opcional)",
    "editor.app.notifImage": "Imagen (opcional)",
    "editor.app.notifUploadImage": "Subir imagen",
    "editor.app.uploading": "Subiendo...",
    "editor.app.notifUrl": "Destino del enlace",
    "editor.app.notifUrlProfile": "Página del perfil",
    "editor.app.notifUrlBlock": "Ir a bloque",
    "editor.app.notifUrlCustom": "URL personalizada",
    "editor.app.notifSelectBlock": "Selecciona un bloque",
    "editor.app.notifPinned": "Fijada — visible para todos los visitantes sin importar cuándo visitaron por primera vez",
    "editor.app.sendNotification": "Enviar Notificación",
    "editor.app.sending": "Enviando...",
    "editor.app.notifSent": "Notificación enviada a {sent} de {total} suscriptores",
    "editor.app.notifHistory": "Notificaciones Enviadas",
    "editor.app.notifEdit": "Editar",
    "editor.app.notifSave": "Guardar",
    "editor.app.notifPin": "Fijar",
    "editor.app.notifUnpin": "Desfijar",
    "editor.app.notifDeleteConfirm": "¿Eliminar esta notificación? Se quitará de la campana de tu perfil.",
    "editor.app.notifEditHint": "Los cambios se ven en la campana de tu perfil. Las notificaciones ya entregadas a los teléfonos no cambian.",
    "editor.app.noNotifications": "Aún no se han enviado notificaciones.",
    "editor.toast.pwaIconUploaded": "Ícono de app actualizado",
    "editor.profileStatus": "Estado del Perfil",
    "editor.statusActive": "Tu perfil está activo y visible",
    "editor.statusInactive": "Tu perfil está oculto para visitantes",
    "editor.business": "Negocio",
    "editor.businessDesc": "Para empresas y {orgLabelPlural}",
    "editor.professional": "Profesional",
    "editor.professionalDesc": "Para individuos y freelancers",
    "editor.personal": "Personal",
    "editor.personalDesc": "Para uso personal y pasatiempos",

    // Profile Editor - Appearance Tab
    "editor.profileImage": "Imagen de Perfil",
    "editor.uploadProfilePhoto": "Clic para subir una foto de perfil.",
    "editor.profilePhotoRec": "Recomendado: 400x400px, JPG o PNG",
    "editor.coverImage": "Imagen de Portada",
    "editor.uploadCoverImage": "Clic para subir una imagen de portada",
    "editor.coverImageRec": "Recomendado: 1200x400px, JPG o PNG",
    "editor.welcomeScreen": "Pantalla de Bienvenida",
    "editor.welcomeScreenDesc": "Muestra una imagen, flyer o video cuando los visitantes abran tu perfil. Pueden verlo de nuevo tocando tu foto de perfil.",
    "editor.uploadWelcomeMedia": "Subir imagen o video",
    "editor.welcomeMediaFormats": "JPG, PNG, GIF, MP4, WebM",
    "editor.removeWelcomeMedia": "Quitar media de bienvenida",
    "editor.welcomeShowWhen": "Mostrar automáticamente:",
    "editor.welcomeAlways": "Cada visita",
    "editor.welcomeOnce": "Una vez por dispositivo",
    "editor.welcomeScan": "Solo al escanear NFC/QR",
    "editor.welcomeNever": "Nunca (tocar foto de perfil)",
    "editor.themeColor": "Color del Tema",
    "editor.currentColor": "Color actual",
    "editor.customColor": "Personalizado",
    "editor.themeStyle": "Estilo del Tema",
    "editor.themePreview": "Vista previa",
    "editor.preview.contact": "Contacto",
    "editor.preview.social": "Redes",
    "editor.preview.badge": "perfil",
    "editor.upload": "Subir",

    // Profile Editor - Blocks Tab
    "editor.blocksExplainer": "Los bloques son las secciones de contenido de tu perfil — agrégalos, reordénalos, renómbralos u ocúltalos aquí.",
    "editor.addBlock": "Agregar Bloque",
    "editor.noBlocks": "Aún no hay bloques.",
    "editor.noBlocksDesc": "Haz clic en \"Agregar Bloque\" para comenzar.",
    "editor.deleteBlock": "¿Eliminar este bloque?",
    "editor.visible": "Visible",
    "editor.hidden": "Oculto",
    "editor.addContact": "Agregar Contacto",
    "editor.addSocialLink": "Agregar Red Social",
    "editor.showTitle": "Mostrar título del bloque como encabezado",
    "editor.noEditor": "No hay editor disponible para este tipo de bloque.",

    // Profile Editor - Block Types
    "editor.blockType.contact_info": "Info de Contacto",
    "editor.blockType.social_links": "Redes Sociales",
    "editor.blockType.about": "Acerca de",
    "editor.blockTitlePlaceholder": "Toca para nombrar esta secci\u00f3n",
    "editor.blockType.custom_text": "Texto Personalizado",
    "editor.blockType.cta_button": "Botón CTA",
    "editor.blockType.website": "Sitio Web",
    "editor.blockType.header": "Encabezado",
    "editor.blockType.location": "Ubicación",
    "editor.blockType.contact_form": "Formulario de Contacto",
    "editor.blockType.gallery": "Galería",
    "editor.blockType.media": "Imagen / Video",
    "editor.blockType.google_review": "Rese\u00f1a de Google",
    "editor.blockType.bank_info": "Datos Bancarios",
    "editor.blockType.map": "Mapa",
    "editor.blockType.payment": "Cobro",
    "editor.blockType.appointment": "Citas",
    "editor.appointment.title": "Citas",
    "editor.appointment.schedule": "Horario de Disponibilidad",
    "editor.appointment.mon": "Lun",
    "editor.appointment.tue": "Mar",
    "editor.appointment.wed": "Mié",
    "editor.appointment.thu": "Jue",
    "editor.appointment.fri": "Vie",
    "editor.appointment.sat": "Sáb",
    "editor.appointment.sun": "Dom",
    "editor.appointment.addRange": "Agregar rango",
    "editor.appointment.services": "Tipos de Servicio",
    "editor.appointment.serviceName": "Nombre del servicio",
    "editor.appointment.serviceDescription": "Descripción (opcional)",
    "editor.appointment.addService": "Agregar servicio",
    "editor.appointment.duration": "Duración",
    "editor.appointment.price": "Precio",
    "editor.appointment.settings": "Configuración",
    "editor.appointment.slotDuration": "Duración base",
    "editor.appointment.bufferTime": "Tiempo entre citas",
    "editor.appointment.minNotice": "Anticipación mínima",
    "editor.appointment.bookingWindow": "Ventana de agenda",
    "editor.appointment.days": "días",
    "editor.appointment.confirmationMode": "Confirmación",
    "editor.appointment.confirmAuto": "Auto-confirmar",
    "editor.appointment.confirmManual": "Aprobación manual",
    "editor.appointment.location": "Ubicación",
    "editor.appointment.locationNone": "No especificada",
    "editor.appointment.locationAddress": "Presencial (dirección)",
    "editor.appointment.locationVideo": "Videollamada",
    "editor.appointment.locationPhone": "Llamada telefónica",
    "editor.appointment.addressPlaceholder": "Ingresar dirección",
    "editor.payment.accessToken": "Access Token de Mercado Pago",
    "editor.payment.accessTokenHelp": "Tu token secreto que empieza con APP_USR-...",
    "editor.payment.howToGet": "¿Cómo obtengo mi token?",
    "editor.payment.step1": "1. Crea tu cuenta de Mercado Pago o inicia sesión",
    "editor.payment.step2": "2. Ve a Configuración:",
    "editor.payment.step3": "3. Entra a Integraciones > Tus integraciones:",
    "editor.payment.step4": "4. Si aún no tienes una aplicación, haz clic en \"Crear aplicación\": escribe un nombre, elige \"Pagos online\", sin plataforma de e-commerce, y el producto \"Checkout Pro\"",
    "editor.payment.step5": "5. Obtén tus credenciales de producción (si te lo pide, actívalas: elige tu industria, escribe tu sitio web —sirve el link de tu perfil— y acepta los términos):",
    "editor.payment.step6": "6. Copia el Access Token de producción (empieza con APP_USR-...) y pégalo arriba. Las credenciales de prueba no cobran dinero real",
    "editor.payment.warning": "Nunca compartas este token. Se almacena de forma segura y nunca se muestra a los visitantes.",
    "editor.payment.description": "Descripción para visitantes (opcional)",
    "editor.payment.descriptionDefault.en": "Send a payment quickly and securely via Mercado Pago.",
    "editor.payment.descriptionDefault.es": "Envía un pago de forma rápida y segura por Mercado Pago.",
    "editor.blockIncomplete": "Falta contenido requerido",
    "editor.payment.items": "Productos / Servicios",
    "editor.payment.itemName": "Nombre del artículo",
    "editor.payment.addItem": "Agregar artículo",
    "editor.payment.allowCustomAmount": "Permitir monto personalizado",
    "editor.payment.installments": "Meses sin intereses",
    "editor.payment.installmentsNone": "Sin meses sin intereses",
    "editor.payment.installmentsMonths": "meses",
    "editor.payment.buttonText": "Texto del botón",
    "editor.payment.buttonTextPlaceholder": "Ej. Pagar Ahora",
    "editor.payment.configured": "Mercado Pago configurado",
    "payment.pay": "Pagar",
    "payment.defaultDescription": "Envía un pago de forma rápida y segura por Mercado Pago.",
    "payment.share": "Compartir enlace de pago",
    "payment.customAmount": "Monto personalizado",
    "payment.processing": "Procesando...",
    "payment.invalidAmount": "Ingresa un monto válido",
    "payment.error": "No se pudo crear el pago. Intenta de nuevo.",
    "appointment.bookNow": "Agendar Cita",
    "appointment.selectService": "Selecciona un servicio",
    "appointment.selectDate": "Selecciona una fecha",
    "appointment.selectTime": "Selecciona un horario",
    "appointment.yourInfo": "Tu Información",
    "appointment.name": "Nombre",
    "appointment.email": "Correo electrónico",
    "appointment.whatsapp": "WhatsApp (opcional)",
    "appointment.notes": "Notas (opcional)",
    "appointment.confirm": "Confirmar Cita",
    "appointment.confirming": "Agendando...",
    "appointment.success": "¡Cita agendada!",
    "appointment.successAuto": "Tu cita ha sido confirmada.",
    "appointment.successManual": "Tu cita está pendiente de confirmación.",
    "appointment.downloadCal": "Agregar al Calendario",
    "appointment.myAppointments": "Mis Citas",
    "appointment.noAppointments": "Aún no tienes citas",
    "appointment.cancel": "Cancelar",
    "appointment.cancelConfirm": "¿Cancelar esta cita?",
    "appointment.cancelDesc": "Esta acción no se puede deshacer. Se notificará al dueño del perfil.",
    "appointment.keepIt": "Mantener",
    "appointment.dismiss": "Descartar",
    "appointment.cancelled": "Cita cancelada",
    "appointment.free": "Gratis",
    "appointment.min": "min",
    "appointment.pending": "Pendiente",
    "appointment.confirmed": "Confirmada",
    "appointment.completed": "Completada",
    "appointment.status.cancelled": "Cancelada",
    "appointment.noSlots": "No hay horarios disponibles para esta fecha",
    "appointment.location": "Ubicación",
    "appointment.videoCall": "Videollamada",
    "appointment.phoneCall": "Llamada telefónica",
    "editor.bank.bankName": "Banco",
    "editor.bank.bankNamePlaceholder": "Ej. BBVA, Banorte, Banamex",
    "editor.bank.clabe": "CLABE",
    "editor.bank.clabePlaceholder": "C\u00f3digo interbancario de 18 d\u00edgitos",
    "editor.bank.accountNumber": "N\u00famero de Cuenta",
    "editor.bank.accountNumberPlaceholder": "N\u00famero de cuenta bancaria",
    "editor.bank.cardNumber": "N\u00famero de Tarjeta",
    "editor.bank.cardNumberPlaceholder": "N\u00famero de tarjeta de d\u00e9bito",
    "editor.bank.beneficiary": "Nombre del Beneficiario",
    "editor.bank.beneficiaryPlaceholder": "Nombre completo del titular",
    "editor.bank.phone": "Tel\u00e9fono Vinculado",
    "editor.bank.phonePlaceholder": "Tel\u00e9fono vinculado a la cuenta",
    "editor.bank.rfc": "RFC",
    "editor.bank.rfcPlaceholder": "RFC (opcional)",
    "editor.bank.reference": "Referencia / Concepto",
    "editor.bank.referencePlaceholder": "Referencia de pago (opcional)",
    "editor.blockType.billing_info": "Datos de Facturaci\u00f3n",
    "editor.billing.rfc": "RFC",
    "editor.billing.rfcPlaceholder": "Ej. XAXX010101000",
    "editor.billing.businessName": "Raz\u00f3n Social",
    "editor.billing.businessNamePlaceholder": "Nombre legal de la empresa",
    "editor.billing.zipCode": "C\u00f3digo Postal",
    "editor.billing.zipCodePlaceholder": "Ej. 20000",
    "editor.billing.taxRegime": "R\u00e9gimen Fiscal",
    "editor.billing.taxRegimePlaceholder": "-- Seleccionar R\u00e9gimen Fiscal --",
    "editor.billing.cfdiUse": "Uso de CFDI",
    "editor.billing.cfdiUsePlaceholder": "-- Seleccionar Uso de CFDI --",
    "editor.billing.billingEmail": "Correo para Facturaci\u00f3n",
    "editor.billing.billingEmailPlaceholder": "Correo para recibir facturas",
    "editor.billing.rfcInvalid": "Formato de RFC inv\u00e1lido",
    "editor.billing.emailInvalid": "Formato de correo inv\u00e1lido",
    "editor.map.address": "Direcci\u00f3n (etiqueta opcional)",
    "editor.map.addressPlaceholder": "ej. Av. Reforma 123, Ciudad de México",
    "editor.map.lat": "Latitud",
    "editor.map.lng": "Longitud",
    "editor.map.zoom": "Zoom",
    "editor.map.hint": "Ingresa las coordenadas para fijar tu ubicación en el mapa. Puedes obtenerlas desde Google Maps haciendo clic derecho en cualquier punto.",
    "editor.media.remove": "Eliminar",
    "editor.media.upload": "Subir imagen o video",
    "editor.media.formats": "JPG, PNG, WebP, GIF, MP4, WebM",
    "editor.media.uploadFailed": "Error al subir",
    "editor.placeholder.placeId": "Google Place ID (ej. ChIJN1t_tDeuEmsR...)",
    "editor.placeholder.placeIdHint": "Encuentra tu Place ID en developers.google.com/maps/documentation/places/web-service/place-id",
    "editor.selectGallery": "Selecciona una galería",
    "editor.noGalleriesAvailable": "No hay galerías. Crea una en la pestaña Galería.",
    "editor.noContactBlock": "No hay bloque de contacto aún.",
    "editor.noSocialBlock": "No hay bloque de redes sociales aún.",

    // Profile Editor - Placeholders
    "editor.placeholder.label": "Etiqueta",
    "editor.placeholder.value": "Valor",
    "editor.placeholder.username": "solo @usuario",
    "editor.placeholder.url": "https://...",
    "editor.placeholder.buttonText": "Texto del bot\u00f3n",
    "editor.placeholder.websiteUrl": "https://ejemplo.com",
    "editor.placeholder.aboutText": "Escribe sobre ti o tu negocio...",
    "editor.placeholder.content": "Contenido...",
    "editor.placeholder.subtitle": "Subtítulo",
    "editor.placeholder.address": "Dirección completa",
    "editor.placeholder.caption": "Descripción",
    "editor.placeholder.linkUrl": "Enlace URL (https://...)",
    "editor.placeholder.linkText": "Texto del enlace (opcional)",
    "editor.placeholder.cardCode": "Ingresa el código de la {cardLabel} (ej. ABCD1234)",
    "editor.placeholder.galleryTitle": "Título de la galería...",

    // Profile Editor - Gallery Tab
    "editor.galleriesDesc": "Las galerías están vinculadas a bloques de galería. Para mostrar una galería en tu perfil, agrega un bloque de galería en la pestaña Bloques.",
    "editor.createGallery": "Crear Galería",
    "editor.editGallery": "Editar Galería",
    "editor.create": "Crear",
    "editor.noGalleries": "Aún no hay galerías.",
    "editor.noGalleriesDesc": "Crea una galería para comenzar a agregar contenido.",
    "editor.deleteGallery": "¿Eliminar esta galería y todo su contenido?",
    "editor.uploading": "Subiendo...",
    "editor.storage": "Almacenamiento",
    "editor.storageAlmostFull": "Almacenamiento casi lleno. Elimina archivos para liberar espacio.",
    "editor.storageFull": "Límite de almacenamiento excedido. Elimina archivos o mejora tu plan.",
    "editor.fileTooBig": "Este video pesa {size} MB. El máximo por archivo es {max} MB — comprímelo o sube un clip más corto.",
    "editor.notEnoughStorage": "Este video pesa {size} MB pero solo tienes {free} MB libres de {max} MB en tu plan. Elimina archivos o mejora tu plan.",
    "editor.uploadLimits": "Videos de hasta {max} MB por archivo · {free} MB libres en tu plan",
    "editor.uploadLimitsNoStorage": "Videos de hasta {max} MB por archivo",
    "editor.uploadMedia": "Subir Archivo",
    "editor.takePhoto": "Tomar Foto",
    "editor.noMedia": "Aún no hay contenido en esta galería.",

    // Profile Editor - Share Tab
    "editor.profileUrl": "URL del Perfil",
    "editor.referrerSource": "Fuente de Rastreo",
    "editor.referrerSourceDesc": "Selecciona una fuente para generar una URL rastreable. Úsala para saber de dónde vienen tus visitas.",
    "editor.referrerNone": "Sin rastreo (enlace directo)",
    "editor.referrerQr": "Código QR",
    "editor.referrerNfc": "{cardLabel} NFC",
    "editor.referrerWhatsapp": "WhatsApp",
    "editor.referrerInstagram": "Instagram",
    "editor.referrerFacebook": "Facebook",
    "editor.referrerEmail": "Correo electrónico",
    "editor.referrerFlyer": "Volante / Impreso",
    "editor.referrerOther": "Otro",
    "editor.copied": "Copiado",
    "editor.copy": "Copiar",
    "editor.open": "Abrir",
    "editor.qrScanDesc": "Escanea este código QR para abrir el perfil en cualquier dispositivo.",
    "editor.downloadQr": "Descargar Código QR",
    "editor.qrShowLogo": "Mostrar imagen de perfil en el código QR",
    "editor.qrUseColor": "Usar color del perfil en el código QR",
    "editor.vcard": "vCard",
    "editor.vcardDesc": "Descarga un archivo vCard para importar este perfil en cualquier app de contactos.",
    "editor.downloadVcardFile": "Descargar vCard (.vcf)",
    "editor.nfcCards": "{cardLabelPlural} NFC",
    "editor.nfcCardsDesc": "Vincula {cardLabelPlural} NFC a este perfil. Cuando alguien escanee la {cardLabel}, será dirigido aquí.",
    "editor.scanNfc": "Escanear {cardLabel} NFC para Vincular",
    "editor.orEnterCode": "O ingresa el código de la {cardLabel} manualmente:",
    "editor.linking": "Vinculando...",
    "editor.linkCard": "Vincular {cardLabel}",
    "editor.noCards": "Aún no hay {cardLabelPlural} vinculadas a este perfil.",
    "editor.analytics": "Analítica",
    "editor.totalViews": "Vistas totales",
    "editor.socialPreview": "Vista Previa Social",
    "editor.socialPreviewDesc": "Cómo se ve tu perfil al compartirlo en redes sociales.",
    "editor.socialPreviewSeoHint": "Usa tu imagen de perfil (o tu portada si no tienes), tu nombre y tu eslogan. Las apps pueden tardar en actualizar un enlace que ya tenían guardado.",
    "editor.socialPreviewUpgrade": "Con tu plan actual, los enlaces compartidos muestran el ícono y la descripción de {appName}. Mejora a {tier} para que muestren tu propia imagen, nombre y eslogan.",
    "editor.socialPreviewUpgradeBtn": "Mejorar plan",
    "editor.profile": "Perfil",
    "editor.digitalProfile": "Perfil Digital",

    // Profile Editor - NFC/QR Modal
    "editor.nfcTap": "Toque NFC",
    "editor.scanQr": "Escanear QR",
    "editor.tapNfcCard": "Toca Tu {cardLabel} NFC",
    "editor.nfcStep1": "Acerca tu {cardLabel} NFC o llavero a tu teléfono",
    "editor.nfcStep2": "Tu navegador abrirá el enlace de la {cardLabel}",
    "editor.nfcStep3": "¡Confirma el perfil y listo!",
    "editor.qrScanCamera": "Apunta tu cámara al código QR de la {cardLabel}",
    "editor.close": "Cerrar",
    "editor.downloadPng": "Descargar PNG",

    // Profile Editor - Crop Modal
    "editor.zoom": "Zoom",
    "editor.cropCancel": "Cancelar",
    "editor.cropUpload": "Recortar y Subir",

    // Profile Editor - Toast Messages
    "editor.toast.profileSaved": "Perfil guardado exitosamente",
    "editor.toast.emptyFields": "Algunos campos de contacto o redes sociales están vacíos",
    "editor.hint.blockMirrorBefore": "Edici\u00f3n r\u00e1pida — para",
    "editor.hint.goToBlock": "administrar bloque",
    "editor.hint.blockMirrorAfter": "(reordenar, renombrar u ocultar) usa la pesta\u00f1a Bloques",
    "editor.toast.profileSaveFailed": "Error al guardar el perfil",
    "editor.toast.profileImageUploaded": "Imagen de perfil subida",
    "editor.toast.coverImageUploaded": "Imagen de portada subida",
    "editor.toast.uploadFailed": "Error al subir la imagen",
    "editor.toast.uploadCancelled": "Subida cancelada",
    "editor.toast.urlCopied": "URL copiada al portapapeles",
    "editor.toast.urlCopyFailed": "Error al copiar la URL",
    "editor.toast.blockAdded": "Bloque {label} agregado",
    "editor.toast.blockAddFailed": "Error al agregar bloque",
    "editor.toast.tierRequired": "Esta función requiere una suscripción Plus",
    "editor.plusBlockWarning": "Este bloque requiere una suscripción Plus. No será visible para los visitantes hasta que actualices.",
    "editor.plusBlocksWarning": "Los bloques marcados con PLUS no se mostrarán públicamente hasta que actualices tu suscripción.",
    "editor.toast.blockUpdateFailed": "Error al actualizar bloque",
    "editor.toast.blockDeleted": "Bloque eliminado",
    "editor.toast.blockDeleteFailed": "Error al eliminar bloque",
    "editor.toast.reorderFailed": "Error al reordenar bloques",
    "editor.toast.contactAddFailed": "Error al agregar contacto",
    "editor.toast.contactUpdateFailed": "Error al actualizar contacto",
    "editor.toast.contactDeleteFailed": "Error al eliminar contacto",
    "editor.toast.socialAddFailed": "Error al agregar red social",
    "editor.toast.socialUpdateFailed": "Error al actualizar red social",
    "editor.toast.socialDeleteFailed": "Error al eliminar red social",
    "editor.toast.galleryCreated": "Galería creada",
    "editor.toast.galleryCreateFailed": "Error al crear galería",
    "editor.toast.galleryUpdateFailed": "Error al actualizar galería",
    "editor.toast.galleryDeleted": "Galería eliminada",
    "editor.toast.galleryDeleteFailed": "Error al eliminar galería",
    "editor.toast.mediaUploaded": "Archivo subido",
    "editor.toast.mediaUploadFailed": "Error al subir archivo",
    "editor.deleteVideoConfirm": "¿Eliminar este video? El archivo se borra permanentemente y libera su espacio en tu plan.",
    "editor.deleteMediaConfirm": "¿Eliminar esta foto? El archivo se borra permanentemente y libera su espacio en tu plan.",
    "editor.toast.uploadInterrupted": "La subida se interrumpió. Revisa tu conexión, o el archivo puede pesar más de {max} MB.",
    "editor.toast.mediaDeleted": "Archivo eliminado",
    "editor.toast.mediaDeleteFailed": "Error al eliminar archivo",
    "editor.toast.cardLinked": "{cardLabel} vinculada exitosamente",
    "editor.toast.cardLinkFailed": "Error al vincular {cardLabel}",
    "editor.toast.cardUnlinked": "{cardLabel} desvinculada",
    "editor.toast.cardUnlinkFailed": "Error al desvincular {cardLabel}",
    "editor.toast.qrNotSupported": "El escaneo QR no es compatible con este navegador. Usa la cámara de tu teléfono.",
    "editor.toast.cameraFailed": "No se pudo acceder a la cámara. Permite los permisos de cámara.",

    // Profile Editor - Media Types
    "editor.mediaType.image": "Imagen",
    "editor.mediaType.video": "Video",
    "editor.mediaType.image_360": "Imagen 360",

    // Profile Editor - Theme Names
    "editor.theme.modern": "Moderno",
    "editor.theme.classic": "Clásico",
    "editor.theme.minimal": "Minimalista",
    "editor.theme.bold": "Audaz",
    "editor.theme.pro": "Pro",
    "editor.theme.instagram": "Instagram",
    "editor.theme.instagramDark": "Instagram Oscuro",

    // Stats Page
    "stats.backToProfile": "Volver al Perfil",
    "stats.title": "Estadísticas",
    "stats.subtitle": "Analítica de actividad",
    "stats.howItWorks": "¿Cómo se cuentan las estadísticas?",
    "stats.rule1": "Tus propias visitas no se cuentan — las estadísticas solo registran la actividad de otras personas.",
    "stats.rule2": "Cada acción de un visitante se cuenta individualmente. Si la misma persona visita 10 veces, cuenta como 10 vistas.",
    "stats.rule3": "Los conteos \"únicos\" muestran cuántos dispositivos diferentes interactuaron, ayudándote a distinguir 100 visitas de 5 personas vs. 100 personas.",
    "stats.rule4": "Los taps de tarjeta registran cuántas veces se escaneó tu tarjeta NFC o código QR.",
    "stats.allEvents": "Todos los Eventos",
    "stats.views": "Visitas",
    "stats.contactClicks": "Clics en Contacto",
    "stats.socialClicks": "Clics en Redes",
    "stats.linkClicks": "Clics en Enlaces",
    "stats.shares": "Compartidos",
    "stats.vcardDownloads": "Descargas vCard",
    "stats.qrScans": "Escaneos QR",
    "stats.days": "{n} días",
    "stats.last": "Últimos {n} días",
    "stats.total": "total",
    "stats.unique": "únicos",
    "stats.cardTaps": "Taps de Tarjeta",
    "stats.noActivity": "Sin actividad en este período",
    "stats.recentEvents": "Eventos Recientes",
    "stats.noEvents": "Aún no hay eventos registrados",
    "stats.referrers": "Fuentes de Tráfico",
    "stats.referrerDirect": "Directo",
    "stats.referrerQr": "Código QR",
    "stats.referrerNfc": "{cardLabel} NFC",
    "stats.referrerWhatsapp": "WhatsApp",
    "stats.referrerInstagram": "Instagram",
    "stats.referrerFacebook": "Facebook",
    "stats.referrerEmail": "Correo electrónico",
    "stats.referrerFlyer": "Volante / Impreso",
    "stats.referrerShare": "Botón Compartir",
    "stats.referrerOther": "Otro",
    "stats.referrerVcard": "vCard",

    "editor.tab.stats": "Estadísticas",
    // CRM / Leads
    "editor.tab.crm": "CRM",
    "crm.title": "Leads",
    "crm.subtitle": "Personas que te contactaron a través de tu perfil",
    "crm.noLeads": "Aún no hay leads. Agrega un bloque de Formulario de Contacto a tu perfil para comenzar a recopilar leads.",
    "crm.statusNew": "Nuevo",
    "crm.statusContacted": "Contactado",
    "crm.statusConverted": "Convertido",
    "crm.statusArchived": "Archivado",
    "crm.allStatuses": "Todos",
    "crm.notes": "Notas",
    "crm.notesPlaceholder": "Agregar notas privadas...",
    "crm.source": "Fuente",
    "crm.delete": "Eliminar",
    "crm.deleteConfirm": "¿Eliminar este lead?",
    "crm.deleteConfirmBtn": "Eliminar",
    "crm.cancel": "Cancelar",
    "crm.exportCsv": "Exportar CSV",
    "crm.pushNotifications": "Notificaciones Push",
    "crm.pushEnabled": "Notificaciones activadas",
    "crm.pushEnable": "Activar notificaciones",
    "crm.pushTooltip": "Recibe notificaciones push de nuevos leads, reseñas y citas",
    "crm.pushDisable": "Desactivar",
    "crm.pushNotSupported": "Las notificaciones push no son compatibles con este navegador",
    "crm.leadsCount": "{count} leads",
    "crm.appointments": "Citas",
    "crm.appointmentsSubtitle": "Administra tus citas agendadas",
    "crm.pushNotifications": "Push",
    "crm.noAppointments": "Aún no hay citas",
    "crm.apptPending": "Pendiente",
    "crm.apptConfirmed": "Confirmada",
    "crm.apptCancelled": "Cancelada",
    "crm.apptCompleted": "Completada",
    "crm.whatsapp": "WhatsApp",
    "crm.call": "Llamar",
    "crm.downloadIcal": "Descargar archivo de calendario",

    // Contact Form Block
    "contactForm.title": "Formulario de Contacto",
    "contactForm.nameLabel": "Nombre",
    "contactForm.namePlaceholder": "Tu nombre",
    "contactForm.emailLabel": "Correo electrónico",
    "contactForm.emailPlaceholder": "tu@correo.com",
    "contactForm.whatsappLabel": "WhatsApp",
    "contactForm.whatsappPlaceholder": "+52 1 234 567 8900",
    "contactForm.messageLabel": "Mensaje",
    "contactForm.messagePlaceholder": "¿En qué podemos ayudarte?",
    "contactForm.submit": "Enviar",
    "contactForm.sending": "Enviando...",
    "contactForm.success": "¡Mensaje enviado exitosamente!",
    "contactForm.error": "No se pudo enviar el mensaje. Intenta de nuevo.",
    "contactForm.alreadySent": "Ya enviaste un mensaje. ¡Gracias!",
    "contactForm.edit": "Editar mis datos",
    "contactForm.update": "Actualizar",
    "contactForm.cancel": "Cancelar",
    "contactForm.showEmail": "Mostrar campo de correo",
    "contactForm.showWhatsapp": "Mostrar campo de WhatsApp",
    "contactForm.showMessage": "Mostrar campo de mensaje",
    "contactForm.requireEmail": "Requerir correo",
    "contactForm.requireWhatsapp": "Requerir WhatsApp",
    "contactForm.buttonText": "Texto del botón",
    "contactForm.successMessage": "Mensaje de éxito",

    // Public Profile
    // Google Review
    "review.title": "Déjanos una Reseña",
    "review.tapToRate": "Toca una estrella para calificar tu experiencia",
    "review.thanks": "¡Gracias por tu opinión!",
    "review.openGoogle": "Completa tu reseña en Google",
    "review.star1": "Malo",
    "review.star2": "Regular",
    "review.star3": "Bueno",
    "review.star4": "Muy Bueno",
    "review.star5": "Excelente",
    "review.feedbackPrompt": "Nos encantaría saber cómo podemos mejorar",
    "review.feedbackPlaceholder": "Cuéntanos sobre tu experiencia...",
    "review.sendFeedback": "Enviar Opinión",
    "review.sending": "Enviando...",
    "review.alreadyReviewed": "Ya enviaste una reseña. ¡Gracias!",

    // Reviews Tab (Editor)
    "editor.tab.reviews": "Reseñas",
    "reviews.totalReviews": "Total Reseñas",
    "reviews.avgRating": "Promedio",
    "reviews.positive": "Positivas (4-5)",
    "reviews.needsWork": "Por Mejorar (1-3)",
    "reviews.breakdown": "Desglose de Calificaciones",
    "reviews.noReviews": "Aún no hay reseñas",
    "reviews.noReviewsDesc": "Las reseñas aparecerán aquí cuando los visitantes califiquen tu perfil.",
    "reviews.redirectedToGoogle": "Redirigido a Google Reviews",
    "reviews.periodAll": "Todo",
    "reviews.periodToday": "Hoy",
    "reviews.periodWeek": "Esta Semana",
    "reviews.periodMonth": "Este Mes",
    "reviews.period3Months": "Últimos 3 Meses",
    "reviews.period6Months": "Últimos 6 Meses",
    "reviews.periodYear": "Último Año",
    "reviews.allStars": "Todas",

    // Cards
    "cards.title": "Mis {cardLabelPlural}",
    "cards.subtitle": "{count} {cardLabel}(s) vinculadas a tu cuenta",
    "cards.noCards": "Aún no hay {cardLabelPlural}",
    "cards.noCardsDesc": "Vincula una {cardLabel} a uno de tus perfiles y aparecerá aquí.",
    "cards.copyUrl": "Copiar URL",
    "cards.scans": "escaneos",
    "cards.unique": "únicos",
    "cards.labelPlaceholder": "ej. Tarjeta de negocios, Evento...",
    "cards.noLabel": "Sin etiqueta",
    "cards.notLinked": "No vinculada a ningún perfil",
    "cards.change": "Cambiar",
    "cards.unlink": "Desvincular",
    "cards.linkProfile": "Vincular a perfil",
    "cards.selectProfile": "Seleccionar Perfil",
    "cards.linkCardTo": "Elige a qué perfil vincular la {cardLabel} {code}:",
    "cards.noProfiles": "No hay perfiles disponibles",

    // Subscriptions
    "subs.title": "Suscripciones",
    "subs.subtitle": "Consulta los planes y estado de suscripción de tus perfiles",
    "subs.active": "Suscripciones Activas",
    "subs.freeTier": "Plan Gratuito",
    "subs.from": "Desde",
    "subs.until": "Hasta",
    "subs.editProfile": "Editar Perfil",
    "subs.viewProfile": "Ver Perfil",
    "subs.allPremium": "¡Todos tus perfiles tienen una suscripción activa!",
    "subs.upgradeHint": "Actualiza este perfil para desbloquear todas las funciones",
    "subs.upgrade": "Mejorar",
    "subs.paymentSuccess": "¡Pago exitoso! Tu suscripción ya está activa.",
    "subs.paymentFailure": "El pago falló. Inténtalo de nuevo.",
    "subs.paymentPending": "El pago se está procesando. Tu suscripción se activará en breve.",
    "subs.history": "Historial",
    "subs.expired": "Expirada",
    "subs.activeLabel": "Activa",
    "subs.daysLeft": "días restantes",

    // Upgrade / Checkout
    "upgrade.back": "Volver a suscripciones",
    "upgrade.title": "Mejorar",
    "upgrade.subtitle": "Desbloquea funciones premium para tu perfil",
    "upgrade.allUpgraded": "\u00a1Todos los perfiles mejorados!",
    "upgrade.allUpgradedDesc": "Todos tus perfiles ya tienen el nivel seleccionado o superior.",
    "upgrade.selectTier": "1. Selecciona nivel",
    "upgrade.selectProfile": "2. Selecciona perfil",
    "upgrade.selectPlan": "3. Elige plan",
    "upgrade.paymentMethod": "4. M\u00e9todo de pago",
    "upgrade.month": "mes",
    "upgrade.months": "meses",
    "upgrade.mo": "mes",
    "upgrade.method.credit_card": "Tarjeta de Crédito / Débito",
    "upgrade.method.credit_card_desc": "Visa, Mastercard, AMEX. Soporta renovación automática.",
    "upgrade.method.spei": "Transferencia SPEI",
    "upgrade.method.spei_desc": "Transferencia bancaria. Pago único, renovación manual.",
    "upgrade.method.cash": "Efectivo (OXXO / Tienda)",
    "upgrade.method.cash_desc": "Paga en cualquier OXXO. Pago único, renovación manual.",
    "upgrade.autoRenew": "Renovar suscripción automáticamente",
    "upgrade.autoRenewDesc": "Se cargará automáticamente a tu tarjeta cada periodo",
    "upgrade.total": "Total",
    "upgrade.pay": "Pagar ahora",
    "upgrade.processing": "Procesando...",
    "upgrade.secure": "Pago seguro con Mercado Pago",
    "upgrade.cardDetails": "Datos de la tarjeta",
    "upgrade.cardNumber": "Número de tarjeta",
    "upgrade.expiration": "Vencimiento",
    "upgrade.cvv": "CVV",
    "upgrade.cardholderName": "Nombre del titular",
    "upgrade.email": "Correo electrónico",
    "upgrade.docType": "Tipo de documento",
    "upgrade.docNumber": "Número de documento",
    "upgrade.issuer": "Banco emisor",
    "upgrade.installments": "Cuotas",
    "upgrade.paymentError": "Hubo un problema con tu pago",
    "upgrade.rejectedGeneric": "Tu pago fue rechazado. Intenta con otra tarjeta o método de pago.",
    "upgrade.rejectedDebit": "Las tarjetas de débito no son compatibles con este pago. Por favor usa una tarjeta de crédito.",

    "public.loading": "Cargando perfil...",
    "public.blockTitle.location": "Ubicación",
    "public.blockTitle.about": "Acerca de",
    "public.blockTitle.contact": "Contacto",
    "public.blockTitle.social": "Redes Sociales",
    "public.blockTitle.learnMore": "Más Información",
    "public.blockTitle.website": "Sitio Web",
    "public.bank.title": "Datos Bancarios",
    "public.bank.bankName": "Banco",
    "public.bank.clabe": "CLABE",
    "public.bank.accountNumber": "N\u00famero de Cuenta",
    "public.bank.cardNumber": "N\u00famero de Tarjeta",
    "public.bank.beneficiary": "Beneficiario",
    "public.bank.phone": "Tel\u00e9fono Vinculado",
    "public.bank.rfc": "RFC",
    "public.bank.reference": "Referencia",
    "public.bank.copy": "Copiar",
    "public.bank.share": "Compartir Datos Bancarios",
    "public.billing.title": "Datos de Facturaci\u00f3n",
    "public.billing.rfc": "RFC",
    "public.billing.businessName": "Raz\u00f3n Social",
    "public.billing.zipCode": "C\u00f3digo Postal",
    "public.billing.taxRegime": "R\u00e9gimen Fiscal",
    "public.billing.cfdiUse": "Uso de CFDI",
    "public.billing.billingEmail": "Correo para Facturaci\u00f3n",
    "public.billing.share": "Compartir Datos de Facturaci\u00f3n",
    "public.notFoundTitle": "Perfil No Encontrado",
    "public.notFoundDesc": "El perfil que buscas no existe o ha sido eliminado.",
    "public.pwaDisabledTitle": "Aplicaci\u00f3n No Disponible",
    "public.pwaDisabledDesc": "Esta aplicaci\u00f3n ya no est\u00e1 disponible. Puedes esperar a que el propietario la habilite de nuevo, o eliminarla de tu dispositivo.",
    "public.pwaDisabledHowTo": "Para eliminar esta aplicaci\u00f3n",
    "public.pwaDisabledAndroid1": "Mant\u00e9n presionado el icono en tu pantalla de inicio",
    "public.pwaDisabledAndroid2": "Toca \"Desinstalar\" o arrastra a \"Eliminar\"",
    "public.pwaDisabledIos1": "Mant\u00e9n presionado el icono en tu pantalla de inicio",
    "public.pwaDisabledIos2": "Toca \"Eliminar marcador\"",
    "public.pwaDisabledIos3": "Toca \"Eliminar\" para confirmar",
    "public.pwaDisabledCopy": "Para ver el perfil en un navegador, copia esta URL:",
    "public.pwaDisabledCopyBtn": "Copiar",
    "public.share": "Compartir",
    "public.shareProfile": "Compartir Perfil",
    "public.viewPhoto": "Ver foto",
    "public.viewWelcome": "Ver pantalla de bienvenida",
    "public.cancel": "Cancelar",
    "public.dontShowAgain": "No mostrar de nuevo",
    "public.viewProfile": "Ver perfil",
    "public.unmute": "Activar sonido",
    "public.copied": "¡Copiado!",
    "public.qrCode": "Código QR",
    "public.save": "Guardar",
    "public.saveContact": "Guardar Contacto",
    "public.installApp": "Instalar {name}",
    "public.installAppDesc": "Agrega este perfil a tu pantalla de inicio para acceso rápido.",
    "public.iosInstallDesc": "2 pasos fáciles desde la barra de Safari:",
    "public.installButton": "Instalar",
    "public.iosInstallHint": "Toca el botón de compartir y luego \"Agregar a pantalla de inicio\".",
    "public.iosStep1": "Toca el botón Compartir en Safari",
    "public.iosStep2": "Toca \"Agregar a inicio\"",
    "public.iosArrowText_before": "Busca el botón",
    "public.iosArrowText_after": "en la barra de Safari",
    "public.iosArrowStep2_before": "Luego toca",
    "public.iosArrowStep2_after": "Agregar a inicio",
    "public.openInMaps": "Abrir en Maps",
    "public.notifications": "Notificaciones",
    "public.noNotifications": "No hay notificaciones aún",
    "public.enableNotifications": "Recibir notificaciones",
    "public.notificationsEnabled": "Notificaciones activadas",
    "public.disableNotifications": "Desactivar",
    "public.dismiss": "Descartar",
    "public.dismissAll": "Limpiar todo",
    "public.notifPromptTitle": "Recibe actualizaciones de {name}",
    "public.notifPromptDesc": "Entérate primero cuando haya algo nuevo.",
    "public.notifPromptAllow": "Activar",
    "public.notifPromptDismiss": "Ahora no",
    "preview.backToEditor": "Volver",
    "preview.previewMode": "Modo vista previa",
    "public.scanQrCode": "Escanear Código QR",
    "public.shareInstantly": "Comparte este perfil al instante",
    "public.sections": "secciones",
    "public.photos": "fotos",

    // Common
    "common.loading": "Cargando...",
    "common.cancel": "Cancelar",
    "common.delete": "Eliminar",
    "common.save": "Guardar",
    "common.language": "Idioma",
    "common.english": "Inglés",
    "common.spanish": "Español",

    // Card claim flow
    "card.welcomeTitle": "¡Tu Nueva {cardLabel}!",
    "card.welcomeSubtitle": "Configura tu perfil digital en segundos.",
    "card.welcomeCode": "{cardLabel} {code}",
    "card.createAccount": "Crear Cuenta",
    "card.iHaveAccount": "Ya tengo una cuenta",
    "card.linkTitle": "Vincular {cardLabel}",
    "card.linkSubtitle": "La {cardLabel} {code} aún no está vinculada.",
    "card.linkTo": "Vincular esta {cardLabel} a:",
    "card.nameYourProfile": "¿Cómo quieres llamar tu perfil?",
    "card.noProfiles": "Aún no tienes perfiles. Se creará uno para ti.",
    "card.confirmLink": "Confirmar y Vincular",
    "card.linking": "Vinculando...",
    "card.linked": "¡{cardLabel} Vinculada!",
    "card.linkedDesc": "Esta {cardLabel} está vinculada a {name}. Cualquiera que la escanee verá este perfil.",
    "card.goToEditor": "Personalizar Tu Perfil",
    "card.linkFailed": "Error al vincular {cardLabel}",
    "card.settingUp": "Configurando tu {cardLabel}...",
    "card.notAvailable": "{cardLabel} no disponible.",
    "card.tooManyRequests": "Demasiadas solicitudes. Intenta de nuevo en un momento.",
    "card.errorTitle": "{cardLabel} No Disponible",
    "card.defaultProfileName": "Mi Perfil",
    "card.createNewProfile": "Crear nuevo perfil",
    "card.createAndLink": "Crear Perfil y Vincular {cardLabel}",
    "card.newProfileName": "Nombre del nuevo perfil",
    "card.useExisting": "Usar un perfil existente",
    "card.maxReached": "Límite de perfiles alcanzado ({max} máx)",
    "card.selectProfile": "Selecciona un perfil",
    "card.typePersonal": "Personal",
    "card.typeBusiness": "Negocio",
    "card.typeProfessional": "Profesional",

    // PWA
    "pwa.installTitle": "Instalar {appName}",
    "pwa.installDesc": "Recibe al instante tus nuevos leads y citas en tu teléfono",
    "pwa.iosInstructions": "Toca Compartir y luego \"Agregar a pantalla de inicio\" (necesario para recibir notificaciones en iPhone)",
    "pwa.installButton": "Instalar",

    // Distributor portal
    "distributor.login_title": "Portal de Distribuidor",
    "distributor.logout": "Cerrar Sesi\u00f3n",
    "distributor.total": "Total",
    "distributor.available": "Disponibles",
    "distributor.sold": "Vendidas",
    "distributor.claimed": "Reclamadas",
    "distributor.scan": "Escanear",
    "distributor.search": "Buscar por c\u00f3digo o etiqueta...",
    "distributor.all": "Todas",
    "distributor.no_match": "No se encontraron tarjetas",
    "distributor.no_cards": "A\u00fan no tienes tarjetas asignadas",
    "distributor.scan_title": "Escanear Tarjeta",
    "distributor.scan_desc": "Elige c\u00f3mo leer la tarjeta.",
    "distributor.scan_qr": "Escanear C\u00f3digo QR",
    "distributor.scan_qr_desc": "Usar c\u00e1mara para leer un c\u00f3digo QR",
    "distributor.scan_nfc": "Leer Tag NFC",
    "distributor.scan_nfc_desc": "Acerca un tag NFC a tu dispositivo",
    "distributor.scan_qr_hint": "Apunta tu c\u00e1mara al c\u00f3digo QR de la tarjeta.",
    "distributor.scan_nfc_reading": "Leyendo NFC...",
    "distributor.scan_nfc_hint": "Acerca un tag NFC a tu dispositivo.",
    "distributor.card_found": "Tarjeta Encontrada",
    "distributor.card_detail": "Detalle de Tarjeta",
    "distributor.close": "Cerrar",
    "distributor.code": "C\u00f3digo",
    "distributor.label": "Etiqueta",
    "distributor.status_label": "Estado",
    "distributor.linked_profile": "Perfil Vinculado",
    "distributor.sale_price": "Precio de Venta (opcional)",
    "distributor.sale_price_placeholder": "0.00",
    "distributor.mark_sold": "Marcar como Vendida",
    "distributor.already_sold": "Esta tarjeta ya fue vendida o reclamada.",
    "distributor.scan_another": "Escanear Otra",
    "distributor.not_found": "Tarjeta No Encontrada",
    "distributor.not_found_desc": "Esta tarjeta no est\u00e1 registrada en el sistema.",
    "distributor.not_yours": "No Es Tu Tarjeta",
    "distributor.not_yours_desc": "Esta tarjeta no est\u00e1 asignada a ti.",
    "distributor.sold_success": "\u00a1Marcada como Vendida!",
    "distributor.sold_success_desc": "ha sido marcada como vendida.",
    "distributor.error": "Error",
    "distributor.try_again": "Reintentar",
    "distributor.status.created": "Creada",
    "distributor.status.printed": "Impresa",
    "distributor.status.ready": "Lista",
    "distributor.status.activated": "Activada",
    "distributor.status.sold": "Vendida",
    "distributor.status.claimed": "Reclamada",
    "distributor.history": "Historial",
    "distributor.history_show_all": "Ver todo ({count})",
    "distributor.history_show_less": "Ver menos",
    "distributor.event.created": "Tarjeta creada",
    "distributor.event.assigned": "Asignada a ti",
    "distributor.event.sold": "Marcada como vendida",
    "distributor.event.claimed": "Reclamada por usuario",
    "distributor.event.status_change": "Estado cambiado",
    "distributor.event.activated": "Activada por admin",
  },
};

export default translations;
